import React, { useMemo, useRef, useState, useCallback,useEffect } from "react";
import { Canvas, useThree } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import * as THREE from "three";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader";
import { STLExporter } from "three/examples/jsm/exporters/STLExporter";
import { CSG } from "three-csg-ts";
import { mergeVertices, mergeBufferGeometries } from "three/examples/jsm/utils/BufferGeometryUtils.js";
import ClipperLib from "clipper-lib";
import * as martinez from "martinez-polygon-clipping";
//import martinez from "martinez-polygon-clipping";
// === TUS IMPORTS DE FUENTES (anteriores) ===
import SuperVanilla from "../../../fonts/Super Vanilla_Regular.json";
import SpookyCartoon from "../../../fonts/Spooky Cartoon_Regular.json";
import KindDaily from "../../../fonts/Kind Daily_Regular.json";
import CandyBeans from "../../../fonts/Candy Beans_Regular.json";
import LastShuriken from "../../../fonts/The Last Shuriken_Regular.json";
import TransformersMovie from "../../../fonts/Transformers Movie_Regular.json";
import ZombieZone from "../../../fonts/Zombie Zone_Regular.json";
import ToastyMilk from "../../../fonts/Toasty Milk_Regular.json";
import Karate from "../../../fonts/Karate_Medium.json";
import SimplyRounded from "../../../fonts/Simply_Rounded_Bold.json";
import HaloDek from "../../../fonts/Halo Dek_Regular.json";
import SundayMidnight from "../../../fonts/Sunday Midnight_Regular.json";

// === NUEVAS FUENTES ===
import LovelyHeart from "../../../fonts/LOVELY HEART_Regular.json";
import MeowInLove from "../../../fonts/Meow in Love Demo_Regular.json";
import MaximumVoltage from "../../../fonts/Maximum Voltage_Regular.json";
import MaximumVoltageItalic from "../../../fonts/Maximum Voltage_Italic.json";
import VampireWars from "../../../fonts/Vampire Wars_Regular.json";
import VampireWarsItalic from "../../../fonts/Vampire Wars_Italic.json";
import Gimbot from "../../../fonts/Gimbot_Regular.json";
import BillyBounce from "../../../fonts/Billy Bounce_Regular.json";
import BlackCastleMF from "../../../fonts/BlackCastleMF_Regular.json";
import CandyShop from "../../../fonts/Candy Shop_Regular.json";
import CandyShopBlack from "../../../fonts/Candy Shop Black_Regular.json";
import AngryBirds from "../../../fonts/AngryBirds_Regular.json";
import Tomcat from "../../../fonts/Tomcat_Regular.json";
import Comicoon from "../../../fonts/Comicoon_Regular.json";
import Grinched from "../../../fonts/Grinched_Regular.json";
import Kraash from "../../../fonts/Kraash_Regular.json";
import KraashBlack from "../../../fonts/Kraash Black_Regular.json";
import Powerful from "../../../fonts/Powerful_Regular.json";
import MilkyNice from "../../../fonts/Milky Nice_Regular.json";
import MilkyNiceClean from "../../../fonts/Milky Nice Clean_Regular.json";
import SuperMario256 from "../../../fonts/Super Mario 256_Regular.json";
import Dinosaur from "../../../fonts/Dinosaur_Regular.json";
import SealightWhisper from "../../../fonts/Sealight Whisper_Regular.json";
import Yourmate from "../../../fonts/Yourmate_Regular.json";
import BubbleGum from "../../../fonts/BubbleGum_Regular.json";
import MagicSound from "../../../fonts/Magic Sound_Regular.json";
import Bestime from "../../../fonts/Bestime_Regular.json";
import SuperBoys from "../../../fonts/Super Boys_Regular.json";
import MilkshakeCreps from "../../../fonts/Milkshake Creps_Regular.json";
import GrindAndDeath from "../../../fonts/GrindAndDeath_Demo_Regular.json";
import GodOfWar from "../../../fonts/GodOfWar_Regular.json";
import Dynamix from "../../../fonts/Dynamix_Regular.json";

import { SimplifyModifier } from "three/examples/jsm/modifiers/SimplifyModifier.js";

const fuentesDisponibles = {

  // === ANTERIORES ===
  "Super Vanilla": SuperVanilla,
  //"Spooky Cartoon": SpookyCartoon,
  "Kind Daily": KindDaily,
  "Candy Beans": CandyBeans,
  "The Last Shuriken": LastShuriken,
  "Transformers Movie": TransformersMovie,
  //"Zombie Zone": ZombieZone,
  "Toasty Milk": ToastyMilk,
  "Karate": Karate,
  "Simply Rounded": SimplyRounded,
  "Halo Dek": HaloDek,
  //"Sunday Midnight": SundayMidnight,

  // === NUEVAS ===
  //"Lovely Heart": LovelyHeart,
  "Meow in Love Demo": MeowInLove,
  //"Maximum Voltage": MaximumVoltage,
  //"Maximum Voltage Italic": MaximumVoltageItalic,
  //"Vampire Wars": VampireWars,
  //"Vampire Wars Italic": VampireWarsItalic,
  "Gimbot": Gimbot,
  //"Billy Bounce": BillyBounce,
  //"BlackCastleMF": BlackCastleMF,
  //"Candy Shop": CandyShop,
  //"Candy Shop Black": CandyShopBlack,
  "AngryBirds": AngryBirds,
  "Tomcat": Tomcat,
  "Comicoon": Comicoon,
  //"Grinched": Grinched,
  //"Kraash": Kraash,
  //"Kraash Black": KraashBlack,
  //"Powerful": Powerful,
  "Milky Nice": MilkyNice,
  //"Milky Nice Clean": MilkyNiceClean,
  //"Super Mario 256": SuperMario256,
 // "Dinosaur": Dinosaur,
  //"Sealight Whisper": SealightWhisper,
  "Yourmate": Yourmate,
  "BubbleGum": BubbleGum,
  //"Magic Sound": MagicSound,
  "Bestime": Bestime,
  "Super Boys": SuperBoys,
  //"Milkshake Creps": MilkshakeCreps,
  //"GrindAndDeath Demo": GrindAndDeath,
  //"God Of War": GodOfWar,
  //"Dynamix": Dynamix,
};

export default function GeneradorLampara2D() {
  const [nombre, setNombre] = useState("ELIAN");
  const [size, setSize] = useState(155);
  const [contornoDistancia, setContornoDistancia] = useState(5);
  const [bordeNegroDistancia, setBordeNegroDistancia] = useState(-2.5);
  const [fuenteSeleccionada, setFuenteSeleccionada] = useState("Transformers Movie");
  const [espaciado, setEspaciado] = useState(0);

  // UI agujeros
  const [agregarAgujeros, setAgregarAgujeros] = useState(true);
  const [rects, setRects] = useState([]); // {id,x,y,w,h}
  const [selectedId, setSelectedId] = useState(null);
  // junto a los otros useState (por ejemplo near size, contornoDistancia, etc.)
const [zoom, setZoom] = useState(1.3); // zoom para la previsualización (no afecta el STL)

///////////////////////////////////////////////////////////
// Estado para puntillas
const [pins, setPins] = useState([]);
const [selectedPinId, setSelectedPinId] = useState(null);
// Radio de la puntilla (mm). Cabeza 5mm -> radio 2.5 mm
const PIN_RADIUS_MM = 2.5;
///////////////////////////////////////////////////////////


  const precisionEscala = 100;

  const BASE_DEPTH = 60; // tu sólido total
  const BASE_CUT = 55; // tu sólido total CORTE
  
  // ======== CANAL INTERNO (tubería) ========
  const WALL_THICKNESS_TOP_BOTTOM = 2; // deja piel arriba y abajo
  const CHANNEL_Z = 11;
  const CHANNEL_DEPTH = 12; // 16mm

  // Parámetro del ancho del delineado naranja (en unidades de fuente)
  const orangeStrokeDist = 3;
  const ORANGE_DEPTH = 50; // <- poner 16 si prefieres 16mm en lugar de 13
  const bordeblancoalto = 50; // <- poner 16 si prefieres 16mm en lugar de 13

  const CURVE_SEGMENTS = 4;
  const SAMPLE_POINTS = 24;

// ======== PARÁMETROS DE LA LÁMPARA ========
const [profundidadBase, setProfundidadBase] = useState(20);  // BASE_DEPTH
const [espesorPared, setEspesorPared] = useState(2);         // WALL_THICKNESS_TOP_BOTTOM
const [alturaCanal, setAlturaCanal] = useState(6);           // CHANNEL_Z
const [profundidadCanal, setProfundidadCanal] = useState(5); // CHANNEL_DEPTH

const [grosorAnilloNaranja, setGrosorAnilloNaranja] = useState(1.6); // orangeStrokeDist
const [profundidadAnilloNaranja, setProfundidadAnilloNaranja] = useState(11); // ORANGE_DEPTH


  // === Fuente ===
  const font = useMemo(() => new FontLoader().parse(fuentesDisponibles[fuenteSeleccionada]), [fuenteSeleccionada]);

  const coloresBordes = ["#FF0000", "#00AAFF", "#00CC66", "#FF9900", "#AA00FF", "#FF66CC"];

  // ===== Aux: área, orientación, shapes de clipper =====
  function polygonArea(points) {
    let a = 0;
    for (let i = 0, l = points.length; i < l; i++) {
      const p1 = points[i];
      const p2 = points[(i + 1) % l];
      a += p1.X * p2.Y - p2.X * p1.Y;
    }
    return a / 2;
  }
  function clipperToVector2(points, flipIfNegative = true) {
    const arr = points.map((pt) => new THREE.Vector2(pt.X / precisionEscala, pt.Y / precisionEscala));
    const area = polygonArea(points);
    if (flipIfNegative && area < 0) arr.reverse();
    return arr;
  }
  function pointInPolygon(pt, poly) {
    let inside = false;
    for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
      const xi = poly[i].X, yi = poly[i].Y;
      const xj = poly[j].X, yj = poly[j].Y;
      const intersect = (yi > pt.Y) !== (yj > pt.Y) && pt.X < ((xj - xi) * (pt.Y - yi)) / (yj - yi + 0.0) + xi;
      if (intersect) inside = !inside;
    }
    return inside;
  }
  function makeShapesFromOffsetPaths(offsetPaths) {
    if (!offsetPaths || offsetPaths.length === 0) return [];
    try {
      if (ClipperLib.Clipper && ClipperLib.Clipper.SimplifyPolygons) {
        offsetPaths = ClipperLib.Clipper.SimplifyPolygons(offsetPaths, ClipperLib.PolyFillType.pftNonZero);
      }
    } catch {}
    const polys = offsetPaths.map((p) => ({ pts: p, area: Math.abs(polygonArea(p)) })).sort((a, b) => b.area - a.area);
    const used = new Array(polys.length).fill(false);
    const shapes = [];
    for (let i = 0; i < polys.length; i++) {
      if (used[i]) continue;
      const exterior = polys[i].pts;
      used[i] = true;
      const shape = new THREE.Shape(clipperToVector2(exterior, true));
      for (let j = i + 1; j < polys.length; j++) {
        if (used[j]) continue;
        const testPt = polys[j].pts[Math.floor(polys[j].pts.length / 2)];
        if (pointInPolygon(testPt, exterior)) {
          const holeVecs = clipperToVector2(polys[j].pts, true);
          shape.holes.push(new THREE.Path(holeVecs));
          used[j] = true;
        }
      }
      shapes.push(shape);
    }
    return shapes;
  }
  function CameraZoomController({ zoom }) {
    const { camera } = useThree();
    useEffect(() => {
      if (!camera) return;
      camera.zoom = zoom;
      camera.updateProjectionMatrix();
    }, [zoom, camera]);
    return null;
  }

  // ------------ HELPERS Clipper <-> Three -------------
  function shapeToClipperPaths(shape, precision, translateX = 0, translateY = 0) {
    const paths = [];
    const outer = shape.getPoints(SAMPLE_POINTS).map((p) => ({
      X: Math.round((p.x + translateX) * precision),
      Y: Math.round((p.y + translateY) * precision),
    }));
    if (outer.length > 0) paths.push(outer);

    shape.holes.forEach((hole) => {
      const holePts = hole.getPoints(SAMPLE_POINTS).map((p) => ({
        X: Math.round((p.x + translateX) * precision),
        Y: Math.round((p.y + translateY) * precision),
      }));
      if (holePts.length > 0) paths.push(holePts);
    });
    return paths;
  }
function clipperPathsToThreeShapes(paths, precision) {
  const polyPoints = paths.map((p) => p.map((pt) => new THREE.Vector2(pt.X / precision, pt.Y / precision)));

  const polygonArea = (pts) => {
    let a = 0;
    for (let i = 0; i < pts.length; i++) {
      const p1 = pts[i];
      const p2 = pts[(i + 1) % pts.length];
      a += p1.x * p2.y - p2.x * p1.y;
    }
    return a / 2;
  };

  const pointInPoly = (pt, poly) => {
    let inside = false;
    for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
      const xi = poly[i].x, yi = poly[i].y;
      const xj = poly[j].x, yj = poly[j].y;
      const intersect = ((yi > pt.y) !== (yj > pt.y)) &&
        (pt.x < (xj - xi) * (pt.y - yi) / (yj - yi + 0.0000001) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  };

  let outers = [];
  let holes = [];
  polyPoints.forEach((pts) => {
    const a = polygonArea(pts);
    if (a > 0) outers.push({ pts, area: a });
    else holes.push({ pts, area: a });
  });

  if (outers.length === 0 && holes.length > 0) {
    outers = holes.map(h => ({ pts: h.pts, area: -h.area }));
    holes = [];
  }

  const shapes = outers.map(o => ({ outer: o.pts, holes: [] }));
  holes.forEach((h) => {
    let attached = false;
    for (let s of shapes) {
      if (pointInPoly(h.pts[0], s.outer)) {
        s.holes.push(h.pts);
        attached = true;
        break;
      }
    }
    if (!attached) shapes.push({ outer: h.pts, holes: [] });
  });

  const threeShapes = shapes.map((s) => {
    const shape = new THREE.Shape(s.outer);
    s.holes.forEach(h => shape.holes.push(new THREE.Path(h)));
    return shape;
  });

  return threeShapes;
}
// ---------------------------------------------------

// ======= Geometrías de letras =======
const letrasData = useMemo(() => {
  const shapesBase = font.generateShapes(nombre, size, CURVE_SEGMENTS);
  const geometriaTexto = new THREE.ShapeGeometry(shapesBase);
  geometriaTexto.computeBoundingBox();

  const anchoTotal = geometriaTexto.boundingBox.max.x - geometriaTexto.boundingBox.min.x;
  const altoTotal = geometriaTexto.boundingBox.max.y - geometriaTexto.boundingBox.min.y;

  let offsetX = -anchoTotal / 2;
  const lettersInfo = [];

  // --- PRIMER PASO: info base por letra ---
  for (let i = 0; i < nombre.length; i++) {
    const letra = nombre[i];
    const shapesLetra = font.generateShapes(letra, size, CURVE_SEGMENTS);
    const geomLetra = new THREE.ShapeGeometry(shapesLetra);
    geomLetra.computeBoundingBox();

    const anchoLetra = geomLetra.boundingBox.max.x - geomLetra.boundingBox.min.x;
    geomLetra.translate(-anchoLetra / 2, -altoTotal / 2, 0);

    const basePaths = [];
    shapesLetra.forEach((shape) => {
      const paths = shapeToClipperPaths(shape, precisionEscala, 0, 0);
      paths.forEach(p => basePaths.push(p));
    });

    const posX = offsetX + anchoLetra / 2;

    lettersInfo.push({
      letra,
      shapesLetra,
      geomLetra,
      anchoLetra,
      offsetX,
      posX,
      basePaths,
    });

    offsetX += anchoLetra + espaciado;
  }

  // --- helper para separar outer / holes ---
  function separateOutersAndHoles(paths) {
    const areas = paths.map(p => {
      let a = 0;
      for (let i = 0; i < p.length; i++) {
        const p1 = p[i];
        const p2 = p[(i + 1) % p.length];
        a += p1.X * p2.Y - p2.X * p1.Y;
      }
      return a / 2;
    });

    const outers = [];
    const holes = [];
    paths.forEach((p, i) => {
      if (areas[i] > 0) outers.push(p); // exterior
      else holes.push(p);              // agujero
    });

    return { outers, holes };
  }

  // --- SEGUNDO PASO: geometrías con contorno, negro, blanco recortado y anillo naranja ---
  const letras = [];
  const contornoRawByIndex = [];

  for (let i = 0; i < lettersInfo.length; i++) {
    const info = lettersInfo[i];

    // separa contornos y agujeros de ESTA letra
    const { outers, holes } = separateOutersAndHoles(info.basePaths);
    const offsetPaths = [];

    const co = new ClipperLib.ClipperOffset(); 
    co.AddPaths(info.basePaths, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon); 
    co.Execute(offsetPaths, contornoDistancia * precisionEscala); 
    const offsetPathsRaw = offsetPaths.map(p => p.map(pt => ({ X: pt.X, Y: pt.Y }))); contornoRawByIndex[i] = offsetPathsRaw; 
    const contornoShapesThree = clipperPathsToThreeShapes(offsetPaths, precisionEscala); 
    const geomContorno = contornoShapesThree.length > 0 ? new THREE.ShapeGeometry(contornoShapesThree) : new THREE.ShapeGeometry([]); geomContorno.translate(-info.anchoLetra / 2, -altoTotal / 2, 0);


    // borde negro (inset)
    const co2 = new ClipperLib.ClipperOffset();
    co2.AddPaths(info.basePaths, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
    const offsetPaths2 = [];
    co2.Execute(offsetPaths2, bordeNegroDistancia * precisionEscala);

    // prev contornos desplazados + prev base para recortar blanco
    const prevContornoShifted = [];
    const prevBaseShifted = [];
    for (let j = 0; j < i; j++) {
      const prevInfo = lettersInfo[j];
      const deltaXprev = Math.round((prevInfo.offsetX - info.offsetX) * precisionEscala);

      const prevRaw = contornoRawByIndex[j];
      if (prevRaw) {
        prevRaw.forEach((p) => {
          const shifted = p.map(pt => ({ X: pt.X + deltaXprev, Y: pt.Y }));
          prevContornoShifted.push(shifted);
        });
      }

      if (prevInfo.basePaths) {
        prevInfo.basePaths.forEach((p) => {
          const shiftedBase = p.map(pt => ({ X: pt.X + deltaXprev, Y: pt.Y }));
          prevBaseShifted.push(shiftedBase);
        });
      }
    }

    // recortar blanco (quita negro + letras previas)
    let finalWhitePaths = info.basePaths;
    const combinedClipForWhite = [];
    if (offsetPaths2.length > 0) combinedClipForWhite.push(...offsetPaths2);
    if (prevBaseShifted.length > 0) combinedClipForWhite.push(...prevBaseShifted);

    if (combinedClipForWhite.length > 0 && info.basePaths.length > 0) {
      const cWhite = new ClipperLib.Clipper();
      cWhite.AddPaths(info.basePaths, ClipperLib.PolyType.ptSubject, true);
      cWhite.AddPaths(combinedClipForWhite, ClipperLib.PolyType.ptClip, true);
      const whiteDiff = new ClipperLib.Paths();
      cWhite.Execute(ClipperLib.ClipType.ctDifference, whiteDiff, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
      finalWhitePaths = whiteDiff;
    }

    // anillo naranja
    let orangeRingPaths = [];
    if (prevContornoShifted.length > 0 && info.basePaths.length > 0) {
      const c3 = new ClipperLib.Clipper();
      c3.AddPaths(prevContornoShifted, ClipperLib.PolyType.ptSubject, true);
      c3.AddPaths(info.basePaths, ClipperLib.PolyType.ptClip, true);
      const inter = new ClipperLib.Paths();
      c3.Execute(ClipperLib.ClipType.ctIntersection, inter, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);

      if (inter.length > 0) {
        const co3 = new ClipperLib.ClipperOffset();
        co3.AddPaths(inter, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
        const orangeOffsetPaths = [];
        co3.Execute(orangeOffsetPaths, orangeStrokeDist * precisionEscala);

        if (orangeOffsetPaths.length > 0) {
          const c4 = new ClipperLib.Clipper();
          c4.AddPaths(orangeOffsetPaths, ClipperLib.PolyType.ptSubject, true);
          c4.AddPaths(inter, ClipperLib.PolyType.ptClip, true);
          const ring = new ClipperLib.Paths();
          c4.Execute(ClipperLib.ClipType.ctDifference, ring, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
          orangeRingPaths = ring;
        }
      }
    }

    const whiteShapesThree = clipperPathsToThreeShapes(finalWhitePaths, precisionEscala);
    const geomTextoRecortado = whiteShapesThree.length > 0 ? new THREE.ShapeGeometry(whiteShapesThree) : new THREE.ShapeGeometry([]);
    geomTextoRecortado.translate(-info.anchoLetra / 2, -altoTotal / 2, 0);

    const blackShapesThree = clipperPathsToThreeShapes(offsetPaths2, precisionEscala);
    const geomBordeNegro = blackShapesThree.length > 0 ? new THREE.ShapeGeometry(blackShapesThree) : new THREE.ShapeGeometry([]);
    geomBordeNegro.translate(-info.anchoLetra / 2, -altoTotal / 2, 0);

    const orangeShapesThree = clipperPathsToThreeShapes(orangeRingPaths, precisionEscala);
    const geomOrangeRing = orangeShapesThree.length > 0 ? new THREE.ShapeGeometry(orangeShapesThree) : new THREE.ShapeGeometry([]);
    geomOrangeRing.translate(-info.anchoLetra / 2, -altoTotal / 2, 0);

    letras.push({
      letra: info.letra,
      posX: info.posX,
      anchoLetra: info.anchoLetra,
      offsetX: info.offsetX,
      altoTotal,
      bordeColor: coloresBordes[i % coloresBordes.length],
      textoGeom: geomTextoRecortado,
      contornoGeom: geomContorno,
      bordeNegroGeom: geomBordeNegro,
      orangeGeom: geomOrangeRing,
      shapesLetra: info.shapesLetra,
      shapesContorno: contornoShapesThree,
      shapesBordeNegro: blackShapesThree,
      shapesNaranja: orangeShapesThree,
    });
  }

  return letras;
}, [nombre, size, contornoDistancia, bordeNegroDistancia, espaciado, font]);
const tapas2Data = useMemo(() => {
  const shapesBase = font.generateShapes(nombre, size, CURVE_SEGMENTS);
  const geometriaTexto = new THREE.ShapeGeometry(shapesBase);
  geometriaTexto.computeBoundingBox();

  const anchoTotal = geometriaTexto.boundingBox.max.x - geometriaTexto.boundingBox.min.x;
  const altoTotal = geometriaTexto.boundingBox.max.y - geometriaTexto.boundingBox.min.y;

  let offsetX = -anchoTotal / 2;
  const lettersInfo = [];

  // --- PRIMER PASO: info base por letra ---
  for (let i = 0; i < nombre.length; i++) {
    const letra = nombre[i];
    const shapesLetra = font.generateShapes(letra, size, CURVE_SEGMENTS);
    const geomLetra = new THREE.ShapeGeometry(shapesLetra);
    geomLetra.computeBoundingBox();

    const anchoLetra = geomLetra.boundingBox.max.x - geomLetra.boundingBox.min.x;
    geomLetra.translate(-anchoLetra / 2, -altoTotal / 2, 0);

    const basePaths = [];
    shapesLetra.forEach((shape) => {
      const paths = shapeToClipperPaths(shape, precisionEscala, 0, 0);
      paths.forEach(p => basePaths.push(p));
    });

    const posX = offsetX + anchoLetra / 2;

    lettersInfo.push({
      letra,
      shapesLetra,
      geomLetra,
      anchoLetra,
      offsetX,
      posX,
      basePaths,
    });

    offsetX += anchoLetra + espaciado;
  }

  // --- helper para separar outer / holes ---
  function separateOutersAndHoles(paths) {
    const areas = paths.map(p => {
      let a = 0;
      for (let i = 0; i < p.length; i++) {
        const p1 = p[i];
        const p2 = p[(i + 1) % p.length];
        a += p1.X * p2.Y - p2.X * p1.Y;
      }
      return a / 2;
    });

    const outers = [];
    const holes = [];
    paths.forEach((p, i) => {
      if (areas[i] > 0) outers.push(p); // exterior
      else holes.push(p);              // agujero
    });

    return { outers, holes };
  }

  // --- SEGUNDO PASO: geometrías con contorno, negro, blanco recortado y anillo naranja ---
  const letras = [];
  const contornoRawByIndex = [];

  for (let i = 0; i < lettersInfo.length; i++) {
    const info = lettersInfo[i];

    // separa contornos y agujeros de ESTA letra
    const { outers, holes } = separateOutersAndHoles(info.basePaths);
    const offsetPaths = [];

// --- generar versión con agujeros (outers + holes)
const offsetPathsHoles = [];
if (outers.length > 0) {
  const coOut = new ClipperLib.ClipperOffset();
  coOut.AddPaths(outers, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
  coOut.Execute(offsetPathsHoles, contornoDistancia * precisionEscala);
}

// --- generar versión con corte lateral (basePaths)
const offsetPathsCut = [];
const coCut = new ClipperLib.ClipperOffset();
coCut.AddPaths(info.basePaths, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
coCut.Execute(offsetPathsCut, contornoDistancia * precisionEscala);

// --- combinar ambas: intersección → mantiene corte lateral + agujeros
// --- combinar: usar offset externo (offsetPathsCut) y RESTAR los basePaths (huecos reales)
let finalContornoPaths = offsetPathsCut;
if (offsetPathsCut.length > 0 && info.basePaths && info.basePaths.length > 0) {
  // primero reducimos ligeramente los huecos (basePaths) con un offset -0.3
  const basePathsInset = [];
  const coInset = new ClipperLib.ClipperOffset();
  coInset.AddPaths(info.basePaths, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
  coInset.Execute(basePathsInset, -1.8 * precisionEscala); // 👈 aquí el -0.3

  // luego hacemos la diferencia con esos huecos reducidos
  const cDiff = new ClipperLib.Clipper();
  cDiff.AddPaths(offsetPathsCut, ClipperLib.PolyType.ptSubject, true);
  cDiff.AddPaths(basePathsInset, ClipperLib.PolyType.ptClip, true);
  const diffRes = new ClipperLib.Paths();
  cDiff.Execute(
    ClipperLib.ClipType.ctDifference,
    diffRes,
    ClipperLib.PolyFillType.pftNonZero,
    ClipperLib.PolyFillType.pftNonZero
  );

  if (diffRes && diffRes.length) finalContornoPaths = diffRes;
}

// --- ahora finalContornoPaths es la tapa correcta (con corte + agujeros)
// 🔥 aplicar offset externo global (reducir todo el contorno negro)
if (finalContornoPaths && finalContornoPaths.length > 0) {
  const finalInset = [];
  const coFinal = new ClipperLib.ClipperOffset();
  coFinal.AddPaths(finalContornoPaths, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
  coFinal.Execute(finalInset, -1.0 * precisionEscala);  // 👈 ajuste externo

  if (finalInset.length > 0) {
    finalContornoPaths = finalInset;
  }
}

// --- ahora finalContornoPaths es la tapa correcta (con corte + agujeros)
const contornoShapesThree = clipperPathsToThreeShapes(finalContornoPaths, precisionEscala);
const geomContorno = contornoShapesThree.length > 0
  ? new THREE.ShapeGeometry(contornoShapesThree)
  : new THREE.ShapeGeometry([]);
geomContorno.translate(-info.anchoLetra / 2, -altoTotal / 2, 0);




    // borde negro (inset)
    const co2 = new ClipperLib.ClipperOffset();
    co2.AddPaths(info.basePaths, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
    const offsetPaths2 = [];
    co2.Execute(offsetPaths2, bordeNegroDistancia * precisionEscala);

    // prev contornos desplazados + prev base para recortar blanco
    const prevContornoShifted = [];
    const prevBaseShifted = [];
    for (let j = 0; j < i; j++) {
      const prevInfo = lettersInfo[j];
      const deltaXprev = Math.round((prevInfo.offsetX - info.offsetX) * precisionEscala);

      const prevRaw = contornoRawByIndex[j];
      if (prevRaw) {
        prevRaw.forEach((p) => {
          const shifted = p.map(pt => ({ X: pt.X + deltaXprev, Y: pt.Y }));
          prevContornoShifted.push(shifted);
        });
      }

      if (prevInfo.basePaths) {
        prevInfo.basePaths.forEach((p) => {
          const shiftedBase = p.map(pt => ({ X: pt.X + deltaXprev, Y: pt.Y }));
          prevBaseShifted.push(shiftedBase);
        });
      }
    }

    // recortar blanco (quita negro + letras previas)
    let finalWhitePaths = info.basePaths;
    const combinedClipForWhite = [];
    if (offsetPaths2.length > 0) combinedClipForWhite.push(...offsetPaths2);
    if (prevBaseShifted.length > 0) combinedClipForWhite.push(...prevBaseShifted);

    if (combinedClipForWhite.length > 0 && info.basePaths.length > 0) {
      const cWhite = new ClipperLib.Clipper();
      cWhite.AddPaths(info.basePaths, ClipperLib.PolyType.ptSubject, true);
      cWhite.AddPaths(combinedClipForWhite, ClipperLib.PolyType.ptClip, true);
      const whiteDiff = new ClipperLib.Paths();
      cWhite.Execute(ClipperLib.ClipType.ctDifference, whiteDiff, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
      finalWhitePaths = whiteDiff;
    }

    // anillo naranja
    let orangeRingPaths = [];
    if (prevContornoShifted.length > 0 && info.basePaths.length > 0) {
      const c3 = new ClipperLib.Clipper();
      c3.AddPaths(prevContornoShifted, ClipperLib.PolyType.ptSubject, true);
      c3.AddPaths(info.basePaths, ClipperLib.PolyType.ptClip, true);
      const inter = new ClipperLib.Paths();
      c3.Execute(ClipperLib.ClipType.ctIntersection, inter, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);

      if (inter.length > 0) {
        const co3 = new ClipperLib.ClipperOffset();
        co3.AddPaths(inter, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
        const orangeOffsetPaths = [];
        co3.Execute(orangeOffsetPaths, orangeStrokeDist * precisionEscala);

        if (orangeOffsetPaths.length > 0) {
          const c4 = new ClipperLib.Clipper();
          c4.AddPaths(orangeOffsetPaths, ClipperLib.PolyType.ptSubject, true);
          c4.AddPaths(inter, ClipperLib.PolyType.ptClip, true);
          const ring = new ClipperLib.Paths();
          c4.Execute(ClipperLib.ClipType.ctDifference, ring, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
          orangeRingPaths = ring;
        }
      }
    }

    const whiteShapesThree = clipperPathsToThreeShapes(finalWhitePaths, precisionEscala);
    const geomTextoRecortado = whiteShapesThree.length > 0 ? new THREE.ShapeGeometry(whiteShapesThree) : new THREE.ShapeGeometry([]);
    geomTextoRecortado.translate(-info.anchoLetra / 2, -altoTotal / 2, 0);

    const blackShapesThree = clipperPathsToThreeShapes(offsetPaths2, precisionEscala);
    const geomBordeNegro = blackShapesThree.length > 0 ? new THREE.ShapeGeometry(blackShapesThree) : new THREE.ShapeGeometry([]);
    geomBordeNegro.translate(-info.anchoLetra / 2, -altoTotal / 2, 0);

    const orangeShapesThree = clipperPathsToThreeShapes(orangeRingPaths, precisionEscala);
    const geomOrangeRing = orangeShapesThree.length > 0 ? new THREE.ShapeGeometry(orangeShapesThree) : new THREE.ShapeGeometry([]);
    geomOrangeRing.translate(-info.anchoLetra / 2, -altoTotal / 2, 0);

    letras.push({
      letra: info.letra,
      posX: info.posX,
      anchoLetra: info.anchoLetra,
      offsetX: info.offsetX,
      altoTotal,
      bordeColor: coloresBordes[i % coloresBordes.length],
      textoGeom: geomTextoRecortado,
      contornoGeom: geomContorno,
      bordeNegroGeom: geomBordeNegro,
      orangeGeom: geomOrangeRing,
      shapesLetra: info.shapesLetra,
      shapesContorno: contornoShapesThree,
      shapesBordeNegro: blackShapesThree,
      shapesNaranja: orangeShapesThree,
    });
  }

  return letras;
}, [nombre, size, contornoDistancia, bordeNegroDistancia, espaciado, font]);


  // ====== Limpieza de geometrías ======
  function removeDegenerateTriangles(geom, eps = 1e-6) {
    let g = geom.index ? geom.toNonIndexed() : geom.clone();
    const pos = g.getAttribute("position");
    const arr = pos.array;
    const newPos = [];
    for (let i = 0; i < arr.length; i += 9) {
      const ax = arr[i], ay = arr[i + 1], az = arr[i + 2];
      const bx = arr[i + 3], by = arr[i + 4], bz = arr[i + 5];
      const cx = arr[i + 6], cy = arr[i + 7], cz = arr[i + 8];
      const abx = bx - ax, aby = by - ay, abz = bz - az;
      const acx = cx - ax, acy = cy - ay, acz = cz - az;
      const nx = aby * acz - abz * acy;
      const ny = abz * acx - abx * acz;
      const nz = abx * acy - aby * acx;
      const area2 = Math.sqrt(nx * nx + ny * ny + nz * nz);
      if (area2 > eps) newPos.push(ax, ay, az, bx, by, bz, cx, cy, cz);
    }
    const newG = new THREE.BufferGeometry();
    newG.setAttribute("position", new THREE.Float32BufferAttribute(newPos, 3));
    newG.computeVertexNormals();
    return newG;
  }
  function cleanGeometry(geom) {
    let g = geom.clone();
    if (g.index) g = g.toNonIndexed();
    g = removeDegenerateTriangles(g, 1e-7);
    g = mergeVertices(g, 1e-5);
    g.computeVertexNormals();

    g.deleteAttribute("normal");
    g.deleteAttribute("uv");
    g = g.toNonIndexed(); // triangula
    g.computeVertexNormals();

    return g;
  }
  // ======= Exportar STL (añadido: restar canales internos) =======



  const descargarSTL = () => {
    const exporter = new STLExporter();
    const EPS = 0.05;
  
    const toGlobal = (geom, data, z = 0) => {
      geom.translate(data.posX - data.anchoLetra / 2, -data.altoTotal / 2, z);
      return geom;
    };
  
    // helpers 2D para anillos (igual que ya tenías)
    const shapeToRing = (shape, data) => {
      const pts = shape.getPoints(SAMPLE_POINTS);
      const tx = data.posX - data.anchoLetra / 2;
      const ty = -data.altoTotal / 2;
      return pts.map((p) => [p.x + tx, p.y + ty]);
    };
    const shapesToMartinezPolygon = (outerShapes, holesShapesArray, data) => {
      const polygons = [];
      outerShapes.forEach((outerShape) => {
        const outer = shapeToRing(outerShape, data);
        const holes = (holesShapesArray || []).map((h) => shapeToRing(h, data));
        polygons.push([outer, ...holes]);
      });
      return polygons.length === 1 ? polygons[0] : polygons;
    };
    const centroidOfRing = (ring) => {
      let x = 0, y = 0, a = 0;
      for (let i = 0, l = ring.length; i < l; i++) {
        const [x0, y0] = ring[i];
        const [x1, y1] = ring[(i + 1) % l];
        const cross = x0 * y1 - x1 * y0;
        a += cross; x += (x0 + x1) * cross; y += (y0 + y1) * cross;
      }
      a = a * 0.5;
      if (Math.abs(a) < 1e-9) {
        const avg = ring.reduce((acc, p) => [acc[0] + p[0], acc[1] + p[1]], [0, 0]);
        return [avg[0] / ring.length, avg[1] / ring.length];
      }
      return [x / (6 * a), y / (6 * a)];
    };
    const scaleRingAboutCentroid = (ring, margin) => {
      const [cx, cy] = centroidOfRing(ring);
      let sumR = 0;
      for (const [x, y] of ring) sumR += Math.hypot(x - cx, y - cy);
      const avgR = Math.max(1e-6, sumR / ring.length);
      const scale = 1 + margin / avgR;
      return ring.map(([x, y]) => [cx + (x - cx) * scale, cy + (y - cy) * scale]);
    };
  
  
  
  
    letrasData.forEach((data, idx) => {
      // 1) Base y cortes existentes
      let baseGeom = new THREE.ExtrudeGeometry(data.shapesContorno, { depth: BASE_DEPTH, bevelEnabled: false });
      baseGeom = toGlobal(baseGeom, data, 0);
      baseGeom = cleanGeometry(baseGeom);
      let baseCSG = CSG.fromMesh(new THREE.Mesh(baseGeom));
  
      let letraGeom = new THREE.ExtrudeGeometry(data.shapesLetra, { depth: 55, bevelEnabled: false });
      letraGeom = toGlobal(letraGeom, data, 5 + EPS);
      letraGeom = cleanGeometry(letraGeom);
      const letraCSG = CSG.fromMesh(new THREE.Mesh(letraGeom));
      baseCSG = baseCSG.subtract(letraCSG);
  
      if (idx > 0) {
        const prev = letrasData[idx - 1];
        let prevGeomBase = new THREE.ExtrudeGeometry(prev.shapesContorno, { depth: BASE_DEPTH, bevelEnabled: false });
        prevGeomBase = toGlobal(prevGeomBase, prev, 0);
        prevGeomBase = cleanGeometry(prevGeomBase);
        baseCSG = baseCSG.subtract(CSG.fromMesh(new THREE.Mesh(prevGeomBase)));
      }
  
  
  
  
      // --- INSERTAR: borde circular alrededor de los agujeros interiores (3mm x 25mm) ---
  // pegar justo después de:
  //   baseCSG = baseCSG.subtract(letraCSG);
  //   (y después de restar prevGeomBase si aplica)
  
  // --- CREAR BORDE INTERNO PARA AGUJEROS (letras tipo A, B, D, O, P, R...) ---
  try {
  const BORDER_WIDTH_MM = 3;              // ancho del anillo
  const BORDER_EXTRUDE_HEIGHT = bordeblancoalto || 25; // altura
  const holeRingPaths = [];
  
  // recorrer cada Shape y tomar sus agujeros
  (data.shapesLetra || []).forEach((shape) => {
    (shape.holes || []).forEach((holePath) => {
      // convertir hole a Clipper path
      const holeClipperPaths = shapeToClipperPaths(holePath, precisionEscala, 0, 0);
      holeClipperPaths.forEach((p) => {
        // offset positivo = anillo externo al hueco
        const co = new ClipperLib.ClipperOffset();
        co.AddPath(p, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
        const outPaths = [];
        co.Execute(outPaths, BORDER_WIDTH_MM * precisionEscala);
  
        if (outPaths.length) {
          // restar el hole original del offset para formar el anillo
          const c = new ClipperLib.Clipper();
          c.AddPaths(outPaths, ClipperLib.PolyType.ptSubject, true);
          c.AddPath(p, ClipperLib.PolyType.ptClip, true);
          const ring = new ClipperLib.Paths();
          c.Execute(
            ClipperLib.ClipType.ctDifference,
            ring,
            ClipperLib.PolyFillType.pftNonZero,
            ClipperLib.PolyFillType.pftNonZero
          );
  
          if (ring.length) holeRingPaths.push(...ring);
        }
      });
    });
  });
  
  if (holeRingPaths.length) {
    // convertir Clipper paths → THREE.Shape
    const holeRingShapesThree = clipperPathsToThreeShapes(holeRingPaths, precisionEscala);
    holeRingShapesThree.forEach(
      (s) => s.translate && s.translate(-data.anchoLetra / 2, -data.altoTotal / 2)
    );
  
    // extruir anillo desde z=0
    const ringExtrudeGeom = new THREE.ExtrudeGeometry(holeRingShapesThree, {
      depth: BORDER_EXTRUDE_HEIGHT,
      bevelEnabled: false,
      curveSegments: CURVE_SEGMENTS,
    });
    const ringGeomGlobal = toGlobal(cleanGeometry(ringExtrudeGeom), data, 0);
  
    // unir a la base
    const ringCSG = CSG.fromMesh(new THREE.Mesh(ringGeomGlobal));
    baseCSG = baseCSG.union(ringCSG);
  
    console.debug("[centerBorder] anillo interno creado en letra:", data.letra);
  }
  } catch (err) {
  console.error("[centerBorder] error generando borde interno:", err);
  }
  
  // --- FIN INSERTAR ---
  
  
  
  
  
  // ----------------- DUPLICAR AGUJERO INTERNO Y EXTRUIRLO AL LADO -----------------
  // ----------------- DUPLICAR AGUJERO INTERNO Y EXTRUIRLO EN LA MISMA POSICIÓN -----------------
  try {
  const DUPLICATE_DEPTH = bordeblancoalto + 5 || 25; 
  const duplicatePathsAll = [];
  const OFFSET_DUPLICATE_MM = 2; // offset en mm para agrandar el duplicado
  
  
  (data.shapesLetra || []).forEach((shape) => {
    (shape.holes || []).forEach((holePath) => {
      const holePts = holePath.getPoints(SAMPLE_POINTS).map(p => ({
        X: Math.round(p.x * precisionEscala),
        Y: Math.round(p.y * precisionEscala),
      }));
  
      if (holePts.length > 2) {
        const co = new ClipperLib.ClipperOffset();
        co.AddPath(holePts, ClipperLib.JoinType.jtMiter, ClipperLib.EndType.etClosedPolygon);
  
        const offsetPaths = new ClipperLib.Paths();
        co.Execute(offsetPaths, OFFSET_DUPLICATE_MM  * precisionEscala);
  
        if (offsetPaths.length) {
          offsetPaths.forEach(p => duplicatePathsAll.push(p));
        }
      }
    });
  });
  
  if (duplicatePathsAll.length) {
    const duplicateShapes = clipperPathsToThreeShapes(duplicatePathsAll, precisionEscala);
  
    // trasladar cada shape al sistema local de la letra
    duplicateShapes.forEach(s => {
      if (s.translate) s.translate(-data.anchoLetra / 2, -data.altoTotal / 2);
    });
  
    // crear extrusión de la copia
    let dupGeom = new THREE.ExtrudeGeometry(duplicateShapes, {
      depth: DUPLICATE_DEPTH,
      bevelEnabled: false,
      curveSegments: CURVE_SEGMENTS || 16,
    });
    dupGeom = cleanGeometry(dupGeom);
  
    // ✅ mismo toGlobal que la letra original, sin mover al costado
    const dupGlobal = toGlobal(dupGeom, data, 0);
  
    // unir al CSG de la base
    const dupCSG = CSG.fromMesh(new THREE.Mesh(dupGlobal));
    baseCSG = baseCSG.union(dupCSG);
  
    console.debug("[duplicateHole] copia del agujero superpuesta en letra:", data.letra);
  } else {
    console.debug("[duplicateHole] no se detectaron agujeros en letra:", data.letra);
  }
  } catch (errDup) {
  console.error("[duplicateHole] error generando copia del agujero:", errDup);
  }
  // ----------------- FIN DUPLICADO AGUJERO -----------------
  
  // ----------------- FIN DUPLICADO AGUJERO -----------------
  
  
  
      
  
  
  
      // 2) Anillo blanco (y su parche por intersección, como ya tenías)
      const anilloShapes = data.shapesContorno.map((cont) => {
        const s = new THREE.Shape(cont.getPoints(SAMPLE_POINTS));
        data.shapesBordeNegro.forEach((h) => s.holes.push(new THREE.Path(h.getPoints(SAMPLE_POINTS))));
        return s;
      });
      let anilloGeom = new THREE.ExtrudeGeometry(anilloShapes, { depth: bordeblancoalto, bevelEnabled: false });
      anilloGeom = toGlobal(anilloGeom, data, 5 + EPS);
      anilloGeom = cleanGeometry(anilloGeom);
      let anilloCSG = CSG.fromMesh(new THREE.Mesh(anilloGeom));
  
      if (idx > 0) {
        const prev = letrasData[idx - 1];
        let prevGeomRing = new THREE.ExtrudeGeometry(prev.shapesContorno, { depth: bordeblancoalto, bevelEnabled: false });
        prevGeomRing = toGlobal(prevGeomRing, prev, 5 + EPS);
        prevGeomRing = cleanGeometry(prevGeomRing);
        anilloCSG = anilloCSG.subtract(CSG.fromMesh(new THREE.Mesh(prevGeomRing)));
  
        try {
          // ---- 1) poligonos en COORD global (shapeToRing ya aplica tx,ty) ----
          const currPoly = shapesToMartinezPolygon(data.shapesContorno, [], data);
          const prevPoly = shapesToMartinezPolygon(prev.shapesContorno, [], prev);
        
          // intersection = zona que se RESTA (el hueco actual). Puede ser polygon o multipolygon
          const inter = martinez.intersection(currPoly, prevPoly);
          if (!inter) {
            console.debug("[borde] no hay intersección entre", data.letra, "y", prev.letra);
          }
        
          // ---- 2) extraer rings exteriores desde martinez (normalize) ----
          const extractRings = (m) => {
            const rings = [];
            if (!m || !Array.isArray(m)) return rings;
            // martinez puede devolver polygon [ring, hole..] o multipolygon [[[ring,...]], ...]
            const walk = (obj) => {
              if (!Array.isArray(obj)) return;
              const first = obj[0];
              if (first && typeof first[0] === "number") {
                // aquí obj es ring (lista de puntos), lo tomamos como outer ring
                rings.push(obj);
                return;
              }
              for (const child of obj) walk(child);
            };
            walk(m);
            return rings;
          };
          const cutRings = extractRings(inter || []);
          console.debug("[borde] cutRings:", cutRings.length, "letter:", data.letra);
        
  
  const BORDER_DEPTH = 21;            // altura a extruir desde z=0
  const VERT_ROUND_EPS = 1e-4;        // precisión para agrupar vértices (ajustar si hace falta)
  const MIN_LOOP_VERTS = 6;           // mínimo puntos para considerar un loop válido
  const CURVE_SEGMENTS = 16;          // suavidad de la extrusión
  
  // helper: string key para un vértice con redondeo
  const vKey = (x, y, z) => {
  const rx = Math.round(x / VERT_ROUND_EPS) * VERT_ROUND_EPS;
  const ry = Math.round(y / VERT_ROUND_EPS) * VERT_ROUND_EPS;
  const rz = Math.round(z / VERT_ROUND_EPS) * VERT_ROUND_EPS;
  return `${rx.toFixed(6)}|${ry.toFixed(6)}|${rz.toFixed(6)}`;
  };
  
  // helper: extraer aristas límite (edges con count==1) de una geometría BufferGeometry
  const extractBoundaryEdges = (geom) => {
  const posAttr = geom.attributes.position;
  if (!posAttr) return [];
  const pos = posAttr.array;
  const idxAttr = geom.index ? geom.index.array : null;
  
  // map coordKey -> vertex index (unique)
  const vertMap = new Map();
  const verts = []; // list of coordinate arrays by id
  
  const getOrCreateVertexId = (x, y, z) => {
    const k = vKey(x, y, z);
    if (vertMap.has(k)) return vertMap.get(k);
    const id = verts.length;
    verts.push([x, y, z]);
    vertMap.set(k, id);
    return id;
  };
  
  const edgeCount = new Map(); // key "minId_maxId" -> count
  const edgeCoords = new Map(); // key -> [ [x1,y1,z1], [x2,y2,z2] ]
  
  const triCount = idxAttr ? idxAttr.length / 3 : pos.length / 9;
  for (let t = 0; t < triCount; t++) {
    let aIdx, bIdx, cIdx;
    if (idxAttr) {
      aIdx = idxAttr[t * 3] * 3;
      bIdx = idxAttr[t * 3 + 1] * 3;
      cIdx = idxAttr[t * 3 + 2] * 3;
    } else {
      aIdx = t * 9;
      bIdx = aIdx + 3;
      cIdx = aIdx + 6;
    }
    const ax = pos[aIdx], ay = pos[aIdx + 1], az = pos[aIdx + 2];
    const bx = pos[bIdx], by = pos[bIdx + 1], bz = pos[bIdx + 2];
    const cx = pos[cIdx], cy = pos[cIdx + 1], cz = pos[cIdx + 2];
  
    const va = getOrCreateVertexId(ax, ay, az);
    const vb = getOrCreateVertexId(bx, by, bz);
    const vc = getOrCreateVertexId(cx, cy, cz);
  
    const edgesTri = [[va, vb, [ax, ay, az, bx, by, bz]], [vb, vc, [bx, by, bz, cx, cy, cz]], [vc, va, [cx, cy, cz, ax, ay, az]]];
    for (const [v1, v2, coords] of edgesTri) {
      const a = Math.min(v1, v2), b = Math.max(v1, v2);
      const k = `${a}_${b}`;
      const prev = edgeCount.get(k) || 0;
      edgeCount.set(k, prev + 1);
      if (!edgeCoords.has(k)) {
        // store the original coords for the segment (use the rounded vertex positions)
        const p1 = verts[a];
        const p2 = verts[b];
        edgeCoords.set(k, [[p1[0], p1[1], p1[2]], [p2[0], p2[1], p2[2]]]);
      }
    }
  }
  
  // boundary edges are those with count == 1
  const boundaries = [];
  for (const [k, cnt] of edgeCount.entries()) {
    if (cnt === 1) {
      const coords = edgeCoords.get(k);
      if (coords) boundaries.push(coords);
    }
  }
  return boundaries; // array of [ [x1,y1,z1], [x2,y2,z2] ]
  };
  
  // -------------- reconstruir base original y base después de resta --------------
  const baseGeomOriginal = new THREE.ExtrudeGeometry(data.shapesContorno, { depth: BASE_DEPTH, bevelEnabled: false });
  toGlobal(baseGeomOriginal, data, 0);
  const baseOrigMesh = new THREE.Mesh(cleanGeometry(baseGeomOriginal));
  
  const baseAfterMesh = CSG.toMesh(baseCSG, new THREE.Matrix4());
  baseAfterMesh.geometry = cleanGeometry(baseAfterMesh.geometry);
  
  // extraer edges boundary de ambas
  const origBoundEdges = extractBoundaryEdges(baseOrigMesh.geometry);
  const afterBoundEdges = extractBoundaryEdges(baseAfterMesh.geometry);
  
  // crear set de claves para after edges (por coordenadas redondeadas)
  const edgeKeyFromCoords = (c) => {
  const [a, b] = c;
  const ka = vKey(a[0], a[1], a[2]);
  const kb = vKey(b[0], b[1], b[2]);
  return ka < kb ? `${ka}|${kb}` : `${kb}|${ka}`;
  };
  const afterSet = new Set(afterBoundEdges.map(edgeKeyFromCoords));
  
  // filtrar edges que están en orig pero no en after => esos son los cortes
  const diffEdges = origBoundEdges.filter(e => !afterSet.has(edgeKeyFromCoords(e)));
  console.debug("[bordeDiff] origBoundEdges:", origBoundEdges.length, "afterBoundEdges:", afterBoundEdges.length, "diffEdges:", diffEdges.length, "letter:", data.letra);
  
  // si no hay diffEdges -> debug y salir
  if (!diffEdges.length) {
  console.debug("[bordeDiff] no se detectaron segmentos de corte por diferencia de aristas para", data.letra, " - intenta ajustar VERT_ROUND_EPS");
  } else {
  // construir mapa de conectividad para ensamblar loops
  const adj = new Map(); // key vertex -> Set(neighbors)
  const coordMap = new Map(); // key -> [x,y,z]
  
  const ensureVert = (v) => {
    const k = vKey(v[0], v[1], v[2]);
    if (!coordMap.has(k)) coordMap.set(k, [v[0], v[1], v[2]]);
    if (!adj.has(k)) adj.set(k, new Set());
    return k;
  };
  
  for (const seg of diffEdges) {
    const [a, b] = seg;
    const ka = ensureVert(a);
    const kb = ensureVert(b);
    adj.get(ka).add(kb);
    adj.get(kb).add(ka);
  }
  
  // construir loops por recorrido greedily
  const visited = new Set();
  const loops = [];
  for (const start of adj.keys()) {
    if (visited.has(start)) continue;
    let cur = start;
    let prev = null;
    const chain = [cur];
    visited.add(cur);
    // intentar seguir hasta cerrar
    while (true) {
      const neigh = Array.from(adj.get(cur) || []).filter(n => n !== prev);
      if (!neigh.length) break;
      // preferir vecino no visitado
      let next = neigh.find(n => !visited.has(n)) || neigh[0];
      if (next === start) {
        chain.push(next);
        visited.add(next);
        break;
      }
      if (visited.has(next)) {
        // evitar bucle infinito
        break;
      }
      chain.push(next);
      visited.add(next);
      prev = cur;
      cur = next;
      if (chain.length > 20000) break;
    }
    // cerrada?
    if (chain.length >= MIN_LOOP_VERTS && chain[chain.length - 1] === start) {
      // convertir a puntos 2D y calcular area
      const pts2 = chain.slice(0, -1).map(k => {
        const p = coordMap.get(k);
        return [p[0], p[1]];
      });
      // area simple
      const area = Math.abs(pts2.reduce((acc, p, i) => {
        const q = pts2[(i + 1) % pts2.length];
        return acc + p[0] * q[1] - q[0] * p[1];
      }, 0) * 0.5);
      if (area > 1e-6) loops.push({ pts: pts2, area });
    }
  }
  
  console.debug("[bordeDiff] boundary loops count:", loops.length, "letter:", data.letra);
  
  if (!loops.length) {
    console.debug("[bordeDiff] no se detectaron loops cerrados válidos, tal vez ajustar VERT_ROUND_EPS o MIN_LOOP_VERTS");
  } else {
    // escoger loop más grande y generar shape
    loops.sort((a, b) => b.area - a.area);
    const best = loops[0].pts;
    // asegurar orientación CCW
    const signedArea = best.reduce((acc, p, i) => {
      const q = best[(i + 1) % best.length];
      return acc + p[0] * q[1] - q[0] * p[1];
    }, 0) * 0.5;
    if (signedArea < 0) best.reverse();
  
    const shapeVecs = best.map(([x, y]) => new THREE.Vector2(x, y));
    const shape = new THREE.Shape(shapeVecs);
    // extruir borde desde z=0
    let bordeGeom = null;
    try {
      bordeGeom = new THREE.ExtrudeGeometry(shape, { depth: BORDER_DEPTH, bevelEnabled: false, curveSegments: CURVE_SEGMENTS });
      bordeGeom = cleanGeometry(bordeGeom);
    } catch (e) {
      console.warn("[bordeDiff] extrusión fallo:", e);
      bordeGeom = null;
    }
  
    if (bordeGeom && bordeGeom.attributes && bordeGeom.attributes.position && bordeGeom.attributes.position.count >= 10) {
      const bordeMesh = new THREE.Mesh(bordeGeom);
      bordeMesh.updateMatrix();
      try {
        const bordeCSG = CSG.fromMesh(bordeMesh);
        baseCSG = baseCSG.union(bordeCSG);
        console.debug("[bordeDiff] union OK en base para letra:", data.letra);
      } catch (e) {
        console.warn("[bordeDiff] fallo CSG.fromMesh/union:", e);
      }
    } else {
      console.debug("[bordeDiff] bordeGeom inválido o degenerado, no se unió.");
    }
  }
  }
  // === FIN BLOQUE ===
  
  
  
          
        } catch (err) {
          console.error("Error generando borde desde base:", err);
        }
        
        
        
      }
  
      // 3) === RESTAR CANALES INTERNOS DE ESTE LETRERO ===
      // 3) === RESTAR CANALES INTERNOS DE ESTE LETRERO ===
      if (rects.length) {
        // seguridad: que CHANNEL_Z quede dentro del sólido y deje piel arriba/abajo
        const minZ = WALL_THICKNESS_TOP_BOTTOM; // mínimo desde la base
        const maxZ = Math.max(0, BASE_DEPTH - WALL_THICKNESS_TOP_BOTTOM - CHANNEL_DEPTH);
        const safeChannelZ = Math.min(Math.max(CHANNEL_Z, minZ), maxZ);
  
        rects.forEach((r) => {
          // Crear el canal usando la misma referencia de coordenadas que las extrusiones:
         // const canalGeom = new THREE.BoxGeometry(r.w, r.h, CHANNEL_DEPTH);
          // traducimos la geometría igual que a las extrusiones: toGlobal(geom, data, z)
          // NOTA: no usamos 'canalMesh.position' sino la propia geometría para mantener el mismo espacio
         // canalGeom.translate(r.x, r.y, safeChannelZ + CHANNEL_DEPTH / 2);

         const rectDepth = Math.min(r.depth, BASE_DEPTH - 2 * WALL_THICKNESS_TOP_BOTTOM); // límite seguro
const canalGeom = new THREE.BoxGeometry(r.w, r.h, rectDepth);
canalGeom.translate(r.x, r.y, safeChannelZ + rectDepth / 2);

  
          // limpiar/optimizar un poco antes de CSG (opcional)
          const canalGeomClean = cleanGeometry(canalGeom);
  
          const canalMesh = new THREE.Mesh(canalGeomClean);
          canalMesh.updateMatrix(); // importante para que CSG lea la posición/matriz correcta
  
          const canalCSG = CSG.fromMesh(canalMesh);
          baseCSG = baseCSG.subtract(canalCSG);
          anilloCSG = anilloCSG.subtract(canalCSG);
        });
      }
  
  
      if (idx > 0) {
        const prev = letrasData[idx - 1];
        let prevGeomRing = new THREE.ExtrudeGeometry(prev.shapesContorno, { depth: bordeblancoalto, bevelEnabled: false });
        prevGeomRing = toGlobal(prevGeomRing, prev, 5 + EPS);
        prevGeomRing = cleanGeometry(prevGeomRing);
        anilloCSG = anilloCSG.subtract(CSG.fromMesh(new THREE.Mesh(prevGeomRing)));
  
        // ... tu lógica martinez/intersection/cutRings aquí ...
      }
  
      // ------------------ INSERTAR AQUÍ: extrudir anillo naranja ------------------
  
      if (data.shapesNaranja && data.shapesNaranja.length > 0) {
        try {
          // Creamos extrusión a partir de shapesNaranja (ya son THREE.Shape)
          // Si tus shapesNaranja incluyen holes, extrude debe manejarlas bien porque son Shape con paths.
          const orangeShapesForExtrude = data.shapesNaranja.map((s) => {
            // Asegurarnos de reconstruir shape con puntos para evitar referencias raras
            return new THREE.Shape(s.getPoints(SAMPLE_POINTS));
          });
  
          let orangeGeom = new THREE.ExtrudeGeometry(orangeShapesForExtrude, {
            depth: ORANGE_DEPTH,
            bevelEnabled: false,
            curveSegments: CURVE_SEGMENTS,
          });
  
          // misma cota z que el anillo blanco
          orangeGeom = toGlobal(orangeGeom, data, 5 + EPS);
          orangeGeom = cleanGeometry(orangeGeom);
  
          // CSG del anillo naranja
          let orangeCSG = CSG.fromMesh(new THREE.Mesh(orangeGeom));
  
  
          // --- APLICAR CORTES (rects) TAMBIÉN AL ANILLO NARANJA ---
  if (rects && rects.length) {
  // recalcular safeChannelZ (mismo cálculo que usaste antes)
  const minZ = WALL_THICKNESS_TOP_BOTTOM;
  const maxZ = Math.max(0, BASE_DEPTH - WALL_THICKNESS_TOP_BOTTOM - CHANNEL_DEPTH);
  const safeChannelZ = Math.min(Math.max(CHANNEL_Z, minZ), maxZ);
  
  rects.forEach((r) => {
    // crear canal con la misma referencia de coordenadas que las extrusiones
    const canalGeomOrange = new THREE.BoxGeometry(r.w, r.h, CHANNEL_DEPTH);
    canalGeomOrange.translate(r.x, r.y, safeChannelZ + CHANNEL_DEPTH / 2);
  
    const canalGeomCleanOrange = cleanGeometry(canalGeomOrange);
    const canalMeshOrange = new THREE.Mesh(canalGeomCleanOrange);
    canalMeshOrange.updateMatrix();
  
    const canalCSGOrange = CSG.fromMesh(canalMeshOrange);
  
    // restar el canal del orangeCSG para que el hueco se aplique al contorno naranja
    try {
      orangeCSG = orangeCSG.subtract(canalCSGOrange);
    } catch (e) {
      console.warn("[export] fallo restando canal a orangeCSG:", e);
    }
  });
  }
  // ----------------------------------------------------------------
  
  
  
          // Si existe la letra previa: recortamos igual que el anillo blanco para evitar solapados
          if (idx > 0) {
            const prev = letrasData[idx - 1];
            let prevGeomRingForOrange = new THREE.ExtrudeGeometry(prev.shapesContorno, { depth: ORANGE_DEPTH, bevelEnabled: false });
            prevGeomRingForOrange = toGlobal(prevGeomRingForOrange, prev, 5 + EPS);
            prevGeomRingForOrange = cleanGeometry(prevGeomRingForOrange);
            orangeCSG = orangeCSG.subtract(CSG.fromMesh(new THREE.Mesh(prevGeomRingForOrange)));
          }
  
          // Unir el naranja con el anillo blanco (si prefieres separarlo, haz union con baseCSG)
          try {
            anilloCSG = anilloCSG.union(orangeCSG);
            console.debug("[export] orange union OK letter:", data.letra);
          } catch (e) {
            console.warn("[export] fallo al unir orange/anillo:", e);
            // fallback: unir a baseCSG si union con anillo falla
            try {
              baseCSG = baseCSG.union(orangeCSG);
              console.debug("[export] orange unido a baseCSG como fallback para:", data.letra);
            } catch (e2) {
              console.error("[export] no se pudo unir orange a ninguna CSG:", e2);
            }
          }
        } catch (errOrange) {
          console.error("[export] fallo extruir orange para letra", data.letra, errOrange);
        }
      }
      // ---------------------------------------------------------------------------
  
  
  
  
  
      
  
  
      // 4) Merge & export
      const baseMesh = CSG.toMesh(baseCSG, new THREE.Matrix4());
      const ringMesh = CSG.toMesh(anilloCSG, new THREE.Matrix4());
      baseMesh.geometry = cleanGeometry(baseMesh.geometry);
      ringMesh.geometry = cleanGeometry(ringMesh.geometry);
  
      baseMesh.updateMatrix();
      ringMesh.updateMatrix();
      let merged = mergeBufferGeometries(
        [
          baseMesh.geometry.clone().applyMatrix4(baseMesh.matrix),
          ringMesh.geometry.clone().applyMatrix4(ringMesh.matrix),
        ],
        false
      );
      merged = cleanGeometry(merged);
  
      
  
      const tmp = new THREE.Mesh(merged);
      const box = new THREE.Box3().setFromObject(tmp);
      const center = box.getCenter(new THREE.Vector3());
      tmp.geometry.translate(-center.x, -center.y, -center.z);
  
      const stlString = exporter.parse(tmp);
      const blob = new Blob([stlString], { type: "text/plain" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `letra_${data.letra}_${idx}.stl`;
      link.click();
    });
  };
  const descargarTapasSTL = () => {
    const exporter = new STLExporter();
    const EPS = 0.05;
    const OFFSET_EXTERNO = -0.6; // 🔥 ajuste externo en mm (negativo = inset)
    const CLIPPER_SCALE = precisionEscala || 1000;
  
    const toGlobal = (geom, data, z = 0) => {
      geom.translate(data.posX - data.anchoLetra / 2, -data.altoTotal / 2, z);
      return geom;
    };
  
    // helpers 2D para anillos (igual que ya tenías)
    const shapeToRing = (shape, data) => {
      const pts = shape.getPoints(SAMPLE_POINTS);
      const tx = data.posX - data.anchoLetra / 2;
      const ty = -data.altoTotal / 2;
      return pts.map((p) => [p.x + tx, p.y + ty]);
    };
    const shapesToMartinezPolygon = (outerShapes, holesShapesArray, data) => {
      const polygons = [];
      outerShapes.forEach((outerShape) => {
        const outer = shapeToRing(outerShape, data);
        const holes = (holesShapesArray || []).map((h) => shapeToRing(h, data));
        polygons.push([outer, ...holes]);
      });
      return polygons.length === 1 ? polygons[0] : polygons;
    };
    const centroidOfRing = (ring) => {
      let x = 0, y = 0, a = 0;
      for (let i = 0, l = ring.length; i < l; i++) {
        const [x0, y0] = ring[i];
        const [x1, y1] = ring[(i + 1) % l];
        const cross = x0 * y1 - x1 * y0;
        a += cross; x += (x0 + x1) * cross; y += (y0 + y1) * cross;
      }
      a = a * 0.5;
      if (Math.abs(a) < 1e-9) {
        const avg = ring.reduce((acc, p) => [acc[0] + p[0], acc[1] + p[1]], [0, 0]);
        return [avg[0] / ring.length, avg[1] / ring.length];
      }
      return [x / (6 * a), y / (6 * a)];
    };
    const scaleRingAboutCentroid = (ring, margin) => {
      const [cx, cy] = centroidOfRing(ring);
      let sumR = 0;
      for (const [x, y] of ring) sumR += Math.hypot(x - cx, y - cy);
      const avgR = Math.max(1e-6, sumR / ring.length);
      const scale = 1 + margin / avgR;
      return ring.map(([x, y]) => [cx + (x - cx) * scale, cy + (y - cy) * scale]);
    };
  
    // --- helpers clipper para offset (reutilizados) ---
    function threePointsToClipperPath(points) {
      return points.map(p => ({ X: Math.round(p.x * CLIPPER_SCALE), Y: Math.round(p.y * CLIPPER_SCALE) }));
    }
    function clipperPathToThreePoints(path) {
      return path.map(p => new THREE.Vector2(p.X / CLIPPER_SCALE, p.Y / CLIPPER_SCALE));
    }
    function makeShapesFromClipperPaths(paths) {
      return paths.map(path => {
        const pts = clipperPathToThreePoints(path);
        return new THREE.Shape(pts);
      });
    }
    function offsetSinglePathWithClipper(origPoints, deltaMm) {
      const p = threePointsToClipperPath(origPoints);
      const co = new ClipperLib.ClipperOffset();
      co.AddPath(p, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
      const deltaScaled = Math.round(deltaMm * CLIPPER_SCALE);
      const solutionPaths = new ClipperLib.Paths();
      co.Execute(solutionPaths, deltaScaled);
      return solutionPaths;
    }
    function offsetShapesArray(shapes, deltaMm) {
      const out = [];
      if (!shapes || !shapes.length) return out;
      shapes.forEach(s => {
        const pts = s.getPoints(SAMPLE_POINTS);
        const solution = offsetSinglePathWithClipper(pts, deltaMm);
        if (solution && solution.length) {
          makeShapesFromClipperPaths(solution).forEach(ss => out.push(ss));
        }
      });
      return out;
    }
    function offsetTHREEShapeOrPath(shapeOrPath, deltaMm) {
      // fallback que ya tenías por si Clipper falla
      let pts = [];
      try {
        pts = shapeOrPath.getPoints ? shapeOrPath.getPoints(SAMPLE_POINTS) : shapeOrPath;
      } catch (e) {
        if (Array.isArray(shapeOrPath)) pts = shapeOrPath;
        else pts = [];
      }
      if (typeof ClipperLib !== "undefined") {
        const solution = offsetSinglePathWithClipper(pts, deltaMm);
        if (solution && solution.length) {
          return makeShapesFromClipperPaths(solution);
        } else {
          return [];
        }
      }
      if (!pts || pts.length === 0) return [];
      let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      pts.forEach(p => {
        minX = Math.min(minX, p.x); minY = Math.min(minY, p.y);
        maxX = Math.max(maxX, p.x); maxY = Math.max(maxY, p.y);
      });
      const width = maxX - minX, height = maxY - minY;
      const centerX = (minX + maxX) / 2;
      const centerY = (minY + maxY) / 2;
      const avgDim = Math.max(width, height) || 1;
      const scale = Math.max(0.01, (avgDim + 2 * deltaMm) / avgDim);
      const scaledPts = pts.map(p => new THREE.Vector2(
        centerX + (p.x - centerX) * scale,
        centerY + (p.y - centerY) * scale
      ));
      return [ new THREE.Shape(scaledPts) ];
    }
    function offsetPathArray(pathsArray, deltaMm) {
      const out = [];
      if (!pathsArray || !pathsArray.length) return out;
      pathsArray.forEach(p => {
        const res = offsetTHREEShapeOrPath(p, deltaMm);
        if (res && res.length) res.forEach(s => out.push(s));
      });
      return out;
    }
    // Normaliza y limpia shapes antes de extruir
  function cleanShapesArray(shapes, minDist = 0.1) {
  if (!shapes || !shapes.length) return [];
  return shapes.map(s => {
    const pts = s.getPoints(SAMPLE_POINTS);
    // Elimina puntos muy cercanos que crean ruido
    const filtered = pts.filter((p, i) => {
      if (i === 0) return true;
      const prev = pts[i - 1];
      return p.distanceTo(prev) > minDist;
    });
    // Reconstruye la shape con los puntos limpios
    return new THREE.Shape(filtered);
  });
  }
  
  
    // Recorremos todas las tapas (tapas2Data viene de tu hook/useMemo)
    tapas2Data.forEach((data, idx) => {
  
      // ---- NUEVO: aplicar el offset EXTERNO a las SHAPES QUE FORMARÁN LA TAPA (la zona negra),
      // en lugar de aplicarlo al 'shapesContorno' (azul).
      const adjustedShapesLetra = data.shapesLetra && data.shapesLetra.length
        ? offsetPathArray(data.shapesLetra, OFFSET_EXTERNO)
        : [];
      const shapesLetraForTapa = adjustedShapesLetra.length ? adjustedShapesLetra : (data.shapesLetra || []);
  
      const adjustedShapesNaranja = data.shapesNaranja && data.shapesNaranja.length
        ? offsetPathArray(data.shapesNaranja, OFFSET_EXTERNO)
        : [];
      const shapesNaranjaForTapa = adjustedShapesNaranja.length ? adjustedShapesNaranja : (data.shapesNaranja || []);
  
      // --- ahora shapesLetraForTapa y shapesNaranjaForTapa son las que usaremos para construir la base de la tapa
      const baseShapesForTapa = [];
      if (shapesLetraForTapa && shapesLetraForTapa.length) {
        shapesLetraForTapa.forEach((s) => baseShapesForTapa.push(new THREE.Shape(s.getPoints(SAMPLE_POINTS))));
      }
      if (shapesNaranjaForTapa && shapesNaranjaForTapa.length) {
        shapesNaranjaForTapa.forEach((s) => baseShapesForTapa.push(new THREE.Shape(s.getPoints(SAMPLE_POINTS))));
      }
  
      // 1) Base y cortes existentes (igual que tenías)
      // base con offset aplicado EN LA TAPA (no en el contorno azul)
      let baseGeom = new THREE.ExtrudeGeometry(data.shapesContorno, { depth: BASE_DEPTH, bevelEnabled: false });
      baseGeom = toGlobal(baseGeom, data, 0);
      baseGeom = cleanGeometry(baseGeom);
      let baseCSG = CSG.fromMesh(new THREE.Mesh(baseGeom));
  
      // la geometría "letra" que restas de la base física (sigue usando data.shapesLetra original)
      let letraGeom = new THREE.ExtrudeGeometry(data.shapesLetra, { depth: 55, bevelEnabled: false });
      letraGeom = toGlobal(letraGeom, data, 5 + EPS);
      letraGeom = cleanGeometry(letraGeom);
      const letraCSG = CSG.fromMesh(new THREE.Mesh(letraGeom));
      baseCSG = baseCSG.subtract(letraCSG);
  
      if (idx > 0) {
        const prev = tapas2Data[idx - 1];
        let prevGeomBase = new THREE.ExtrudeGeometry(prev.shapesContorno, { depth: BASE_DEPTH, bevelEnabled: false });
        prevGeomBase = toGlobal(prevGeomBase, prev, 0);
        prevGeomBase = cleanGeometry(prevGeomBase);
        baseCSG = baseCSG.subtract(CSG.fromMesh(new THREE.Mesh(prevGeomBase)));
      }
  
      // 2) Anillo blanco (y su parche por intersección, como ya tenías)
      const anilloShapes = data.shapesContorno.map((cont) => {
        const s = new THREE.Shape(cont.getPoints(SAMPLE_POINTS));
        data.shapesBordeNegro.forEach((h) => s.holes.push(new THREE.Path(h.getPoints(SAMPLE_POINTS))));
        return s;
      });
      let anilloGeom = new THREE.ExtrudeGeometry(anilloShapes, { depth: bordeblancoalto, bevelEnabled: false });
      anilloGeom = toGlobal(anilloGeom, data, 5 + EPS);
      anilloGeom = cleanGeometry(anilloGeom);
      let anilloCSG = CSG.fromMesh(new THREE.Mesh(anilloGeom));
  
      if (idx > 0) {
        const prev = tapas2Data[idx - 1];
        let prevGeomRing = new THREE.ExtrudeGeometry(prev.shapesContorno, { depth: bordeblancoalto, bevelEnabled: false });
        prevGeomRing = toGlobal(prevGeomRing, prev, 5 + EPS);
        prevGeomRing = cleanGeometry(prevGeomRing);
        anilloCSG = anilloCSG.subtract(CSG.fromMesh(new THREE.Mesh(prevGeomRing)));
  
        // ... el resto de tu bloque de intersecciones/bordes sigue exactamente igual ...
        // (copié aquí tu lógica completa tal cual en tu original)
        // [omito por brevedad en este snippet, pero en tu código deja el bloque entero tal cual]
          if (idx > 0) {
            const prev = tapas2Data[idx - 1];
            let prevGeomRing = new THREE.ExtrudeGeometry(prev.shapesContorno, { depth: bordeblancoalto, bevelEnabled: false });
            prevGeomRing = toGlobal(prevGeomRing, prev, 5 + EPS);
            prevGeomRing = cleanGeometry(prevGeomRing);
            anilloCSG = anilloCSG.subtract(CSG.fromMesh(new THREE.Mesh(prevGeomRing)));
      
            try {
              // ---- 1) poligonos en COORD global (shapeToRing ya aplica tx,ty) ----
              const currPoly = shapesToMartinezPolygon(data.shapesContorno, [], data);
              const prevPoly = shapesToMartinezPolygon(prev.shapesContorno, [], prev);
      
              // intersection = zona que se RESTA (el hueco actual). Puede ser polygon o multipolygon
              const inter = martinez.intersection(currPoly, prevPoly);
              if (!inter) {
                console.debug("[borde] no hay intersección entre", data.letra, "y", prev.letra);
              }
      
              // ---- 2) extraer rings exteriores desde martinez (normalize) ----
              const extractRings = (m) => {
                const rings = [];
                if (!m || !Array.isArray(m)) return rings;
                const walk = (obj) => {
                  if (!Array.isArray(obj)) return;
                  const first = obj[0];
                  if (first && typeof first[0] === "number") {
                    rings.push(obj);
                    return;
                  }
                  for (const child of obj) walk(child);
                };
                walk(m);
                return rings;
              };
              const cutRings = extractRings(inter || []);
              console.debug("[borde] cutRings:", cutRings.length, "letter:", data.letra);
      
              // ---- BLOQUE DETECCIÓN/RECONSTRUCCIÓN DE BORDES (tal cual lo tenías) ----
              const BORDER_DEPTH = 21;
              const VERT_ROUND_EPS = 1e-4;
              const MIN_LOOP_VERTS = 6;
              const CURVE_SEGMENTS = 16;
      
              const vKey = (x, y, z) => {
                const rx = Math.round(x / VERT_ROUND_EPS) * VERT_ROUND_EPS;
                const ry = Math.round(y / VERT_ROUND_EPS) * VERT_ROUND_EPS;
                const rz = Math.round(z / VERT_ROUND_EPS) * VERT_ROUND_EPS;
                return `${rx.toFixed(6)}|${ry.toFixed(6)}|${rz.toFixed(6)}`;
              };
      
              const extractBoundaryEdges = (geom) => {
                const posAttr = geom.attributes.position;
                if (!posAttr) return [];
                const pos = posAttr.array;
                const idxAttr = geom.index ? geom.index.array : null;
      
                const vertMap = new Map();
                const verts = [];
                const getOrCreateVertexId = (x, y, z) => {
                  const k = vKey(x, y, z);
                  if (vertMap.has(k)) return vertMap.get(k);
                  const id = verts.length;
                  verts.push([x, y, z]);
                  vertMap.set(k, id);
                  return id;
                };
      
                const edgeCount = new Map();
                const edgeCoords = new Map();
      
                const triCount = idxAttr ? idxAttr.length / 3 : pos.length / 9;
                for (let t = 0; t < triCount; t++) {
                  let aIdx, bIdx, cIdx;
                  if (idxAttr) {
                    aIdx = idxAttr[t * 3] * 3;
                    bIdx = idxAttr[t * 3 + 1] * 3;
                    cIdx = idxAttr[t * 3 + 2] * 3;
                  } else {
                    aIdx = t * 9;
                    bIdx = aIdx + 3;
                    cIdx = aIdx + 6;
                  }
                  const ax = pos[aIdx], ay = pos[aIdx + 1], az = pos[aIdx + 2];
                  const bx = pos[bIdx], by = pos[bIdx + 1], bz = pos[bIdx + 2];
                  const cx = pos[cIdx], cy = pos[cIdx + 1], cz = pos[cIdx + 2];
      
                  const va = getOrCreateVertexId(ax, ay, az);
                  const vb = getOrCreateVertexId(bx, by, bz);
                  const vc = getOrCreateVertexId(cx, cy, cz);
      
                  const edgesTri = [[va, vb, [ax, ay, az, bx, by, bz]], [vb, vc, [bx, by, bz, cx, cy, cz]], [vc, va, [cx, cy, cz, ax, ay, az]]];
                  for (const [v1, v2, coords] of edgesTri) {
                    const a = Math.min(v1, v2), b = Math.max(v1, v2);
                    const k = `${a}_${b}`;
                    const prev = edgeCount.get(k) || 0;
                    edgeCount.set(k, prev + 1);
                    if (!edgeCoords.has(k)) {
                      const p1 = verts[a];
                      const p2 = verts[b];
                      edgeCoords.set(k, [[p1[0], p1[1], p1[2]], [p2[0], p2[1], p2[2]]]);
                    }
                  }
                }
      
                const boundaries = [];
                for (const [k, cnt] of edgeCount.entries()) {
                  if (cnt === 1) {
                    const coords = edgeCoords.get(k);
                    if (coords) boundaries.push(coords);
                  }
                }
                return boundaries;
              };
      
              const baseGeomOriginal = new THREE.ExtrudeGeometry(data.shapesContorno, { depth: BASE_DEPTH, bevelEnabled: false });
              toGlobal(baseGeomOriginal, data, 0);
              const baseOrigMesh = new THREE.Mesh(cleanGeometry(baseGeomOriginal));
      
              const baseAfterMesh = CSG.toMesh(baseCSG, new THREE.Matrix4());
              baseAfterMesh.geometry = cleanGeometry(baseAfterMesh.geometry);
      
              const origBoundEdges = extractBoundaryEdges(baseOrigMesh.geometry);
              const afterBoundEdges = extractBoundaryEdges(baseAfterMesh.geometry);
      
              const edgeKeyFromCoords = (c) => {
                const [a, b] = c;
                const ka = vKey(a[0], a[1], a[2]);
                const kb = vKey(b[0], b[1], b[2]);
                return ka < kb ? `${ka}|${kb}` : `${kb}|${ka}`;
              };
              const afterSet = new Set(afterBoundEdges.map(edgeKeyFromCoords));
              const diffEdges = origBoundEdges.filter(e => !afterSet.has(edgeKeyFromCoords(e)));
              console.debug("[bordeDiff] origBoundEdges:", origBoundEdges.length, "afterBoundEdges:", afterBoundEdges.length, "diffEdges:", diffEdges.length, "letter:", data.letra);
      
              if (!diffEdges.length) {
                console.debug("[bordeDiff] no se detectaron segmentos de corte por diferencia de aristas para", data.letra, " - intenta ajustar VERT_ROUND_EPS");
              } else {
                const adj = new Map();
                const coordMap = new Map();
                const ensureVert = (v) => {
                  const k = vKey(v[0], v[1], v[2]);
                  if (!coordMap.has(k)) coordMap.set(k, [v[0], v[1], v[2]]);
                  if (!adj.has(k)) adj.set(k, new Set());
                  return k;
                };
      
                for (const seg of diffEdges) {
                  const [a, b] = seg;
                  const ka = ensureVert(a);
                  const kb = ensureVert(b);
                  adj.get(ka).add(kb);
                  adj.get(kb).add(ka);
                }
      
                const visited = new Set();
                const loops = [];
                for (const start of adj.keys()) {
                  if (visited.has(start)) continue;
                  let cur = start;
                  let prev = null;
                  const chain = [cur];
                  visited.add(cur);
                  while (true) {
                    const neigh = Array.from(adj.get(cur) || []).filter(n => n !== prev);
                    if (!neigh.length) break;
                    let next = neigh.find(n => !visited.has(n)) || neigh[0];
                    if (next === start) {
                      chain.push(next);
                      visited.add(next);
                      break;
                    }
                    if (visited.has(next)) {
                      break;
                    }
                    chain.push(next);
                    visited.add(next);
                    prev = cur;
                    cur = next;
                    if (chain.length > 20000) break;
                  }
                  if (chain.length >= MIN_LOOP_VERTS && chain[chain.length - 1] === start) {
                    const pts2 = chain.slice(0, -1).map(k => {
                      const p = coordMap.get(k);
                      return [p[0], p[1]];
                    });
                    const area = Math.abs(pts2.reduce((acc, p, i) => {
                      const q = pts2[(i + 1) % pts2.length];
                      return acc + p[0] * q[1] - q[0] * p[1];
                    }, 0) * 0.5);
                    if (area > 1e-6) loops.push({ pts: pts2, area });
                  }
                }
      
                console.debug("[bordeDiff] boundary loops count:", loops.length, "letter:", data.letra);
      
                if (!loops.length) {
                  console.debug("[bordeDiff] no se detectaron loops cerrados válidos, tal vez ajustar VERT_ROUND_EPS o MIN_LOOP_VERTS");
                } else {
                  loops.sort((a, b) => b.area - a.area);
                  const best = loops[0].pts;
                  const signedArea = best.reduce((acc, p, i) => {
                    const q = best[(i + 1) % best.length];
                    return acc + p[0] * q[1] - q[0] * p[1];
                  }, 0) * 0.5;
                  if (signedArea < 0) best.reverse();
      
                  const shapeVecs = best.map(([x, y]) => new THREE.Vector2(x, y));
                  const shape = new THREE.Shape(shapeVecs);
                  let bordeGeom = null;
                  try {
                    bordeGeom = new THREE.ExtrudeGeometry(shape, { depth: BORDER_DEPTH, bevelEnabled: false, curveSegments: CURVE_SEGMENTS });
                    bordeGeom = cleanGeometry(bordeGeom);
                  } catch (e) {
                    console.warn("[bordeDiff] extrusión fallo:", e);
                    bordeGeom = null;
                  }
      
                  if (bordeGeom && bordeGeom.attributes && bordeGeom.attributes.position && bordeGeom.attributes.position.count >= 10) {
                    const bordeMesh = new THREE.Mesh(bordeGeom);
                    bordeMesh.updateMatrix();
                    try {
                      const bordeCSG = CSG.fromMesh(bordeMesh);
                      baseCSG = baseCSG.union(bordeCSG);
                      console.debug("[bordeDiff] union OK en base para letra:", data.letra);
                    } catch (e) {
                      console.warn("[bordeDiff] fallo CSG.fromMesh/union:", e);
                    }
                  } else {
                    console.debug("[bordeDiff] bordeGeom inválido o degenerado, no se unió.");
                  }
                }
              }
            } catch (err) {
              console.error("Error generando borde desde base:", err);
            }
          }
      
          // 3) === RESTAR CANALES INTERNOS DE ESTE LETRERO ===
          if (rects.length) {
            const minZ = WALL_THICKNESS_TOP_BOTTOM;
            const maxZ = Math.max(0, BASE_DEPTH - WALL_THICKNESS_TOP_BOTTOM - CHANNEL_DEPTH);
            const safeChannelZ = Math.min(Math.max(CHANNEL_Z, minZ), maxZ);
      
            rects.forEach((r) => {
              const canalGeom = new THREE.BoxGeometry(r.w, r.h, CHANNEL_DEPTH);
              canalGeom.translate(r.x, r.y, safeChannelZ + CHANNEL_DEPTH / 2);
              const canalGeomClean = cleanGeometry(canalGeom);
              const canalMesh = new THREE.Mesh(canalGeomClean);
              canalMesh.updateMatrix();
              const canalCSG = CSG.fromMesh(canalMesh);
              baseCSG = baseCSG.subtract(canalCSG);
              anilloCSG = anilloCSG.subtract(canalCSG);
            });
          }
      
          if (idx > 0) {
            const prev = tapas2Data[idx - 1];
            let prevGeomRing = new THREE.ExtrudeGeometry(prev.shapesContorno, { depth: bordeblancoalto, bevelEnabled: false });
            prevGeomRing = toGlobal(prevGeomRing, prev, 5 + EPS);
            prevGeomRing = cleanGeometry(prevGeomRing);
            anilloCSG = anilloCSG.subtract(CSG.fromMesh(new THREE.Mesh(prevGeomRing)));
          }
      
          // ------------------ extrudir anillo naranja (igual que antes) ------------------
          if (data.shapesNaranja && data.shapesNaranja.length > 0) {
            try {
              const orangeShapesForExtrude = data.shapesNaranja.map((s) => new THREE.Shape(s.getPoints(SAMPLE_POINTS)));
      
              let orangeGeom = new THREE.ExtrudeGeometry(orangeShapesForExtrude, {
                depth: ORANGE_DEPTH,
                bevelEnabled: false,
                curveSegments: CURVE_SEGMENTS,
              });
      
              orangeGeom = toGlobal(orangeGeom, data, 5 + EPS);
              orangeGeom = cleanGeometry(orangeGeom);
      
              let orangeCSG = CSG.fromMesh(new THREE.Mesh(orangeGeom));
      
              if (rects && rects.length) {
                const minZ = WALL_THICKNESS_TOP_BOTTOM;
                const maxZ = Math.max(0, BASE_DEPTH - WALL_THICKNESS_TOP_BOTTOM - CHANNEL_DEPTH);
                const safeChannelZ = Math.min(Math.max(CHANNEL_Z, minZ), maxZ);
      
                rects.forEach((r) => {
                  const canalGeomOrange = new THREE.BoxGeometry(r.w, r.h, CHANNEL_DEPTH);
                  canalGeomOrange.translate(r.x, r.y, safeChannelZ + CHANNEL_DEPTH / 2);
      
                  const canalGeomCleanOrange = cleanGeometry(canalGeomOrange);
                  const canalMeshOrange = new THREE.Mesh(canalGeomCleanOrange);
                  canalMeshOrange.updateMatrix();
      
                  const canalCSGOrange = CSG.fromMesh(canalMeshOrange);
                  try {
                    orangeCSG = orangeCSG.subtract(canalCSGOrange);
                  } catch (e) {
                    console.warn("[export] fallo restando canal a orangeCSG:", e);
                  }
                });
              }
      
              if (idx > 0) {
                const prev = tapas2Data[idx - 1];
                let prevGeomRingForOrange = new THREE.ExtrudeGeometry(prev.shapesContorno, { depth: ORANGE_DEPTH, bevelEnabled: false });
                prevGeomRingForOrange = toGlobal(prevGeomRingForOrange, prev, 5 + EPS);
                prevGeomRingForOrange = cleanGeometry(prevGeomRingForOrange);
                orangeCSG = orangeCSG.subtract(CSG.fromMesh(new THREE.Mesh(prevGeomRingForOrange)));
              }
      
              try {
                anilloCSG = anilloCSG.union(orangeCSG);
                console.debug("[export] orange union OK letter:", data.letra);
              } catch (e) {
                console.warn("[export] fallo al unir orange/anillo:", e);
                try {
                  baseCSG = baseCSG.union(orangeCSG);
                  console.debug("[export] orange unido a baseCSG como fallback para:", data.letra);
                } catch (e2) {
                  console.error("[export] no se pudo unir orange a ninguna CSG:", e2);
                }
              }
            } catch (errOrange) {
              console.error("[export] fallo extruir orange para letra", data.letra, errOrange);
            }
          }
          // ---------------------------------------------------------------------------
      
      }
  
      // ---------- CONSTRUCCIÓN Y EXPORT DE LA "TAPA RESULTANTE" ----------
      try {
        // Construimos la tapa base usando las shapes LETRA offsetadas (shapesLetraForTapa)
        const TAPA_BASE_DEPTH = 3;
        const TAPA_BORDER_DEPTH = 6;
        const EPS_Z = EPS || 0;
        const OFFSET_MM = 0;
  
        let tapaBaseGeom = new THREE.ExtrudeGeometry(baseShapesForTapa, {
          depth: TAPA_BASE_DEPTH,
          bevelEnabled: false,
          curveSegments: CURVE_SEGMENTS,
        });
        tapaBaseGeom = toGlobal(tapaBaseGeom, data, 0);
        tapaBaseGeom = cleanGeometry(tapaBaseGeom);
        const tapaBaseMesh = new THREE.Mesh(tapaBaseGeom);
        tapaBaseMesh.updateMatrix();
        let tapaBaseCSG = CSG.fromMesh(tapaBaseMesh);
  
        // aplicar recortes de canales (rects) a la base, si existen
        if (rects && rects.length) {
          const minZ = WALL_THICKNESS_TOP_BOTTOM;
          const maxZ = Math.max(0, BASE_DEPTH - WALL_THICKNESS_TOP_BOTTOM - CHANNEL_DEPTH);
          const safeChannelZ = Math.min(Math.max(CHANNEL_Z, minZ), maxZ);
          rects.forEach((r) => {
            const canalGeom = new THREE.BoxGeometry(r.w, r.h, CHANNEL_DEPTH);
            canalGeom.translate(r.x, r.y, safeChannelZ + CHANNEL_DEPTH / 2);
            const canalClean = cleanGeometry(canalGeom);
            const canalMesh = new THREE.Mesh(canalClean);
            canalMesh.updateMatrix();
            const canalCSG = CSG.fromMesh(canalMesh);
            try {
              tapaBaseCSG = tapaBaseCSG.subtract(canalCSG);
            } catch (e) {
              console.warn("[tapa] fallo restando canal a tapaBaseCSG:", e);
            }
          });
        }
  
        // Restar shapesLetraForTapa (las letras offsetadas) a la tapa base para crear el hueco correcto
        if (shapesLetraForTapa && shapesLetraForTapa.length) {
          try {
            const letraShapesForCut = shapesLetraForTapa;
            let letraGeomCut = new THREE.ExtrudeGeometry(letraShapesForCut, { depth: TAPA_BASE_DEPTH + 10, bevelEnabled: false });
            letraGeomCut = toGlobal(letraGeomCut, data, 5 + EPS);
            letraGeomCut = cleanGeometry(letraGeomCut);
            const letraCSGcut = CSG.fromMesh(new THREE.Mesh(letraGeomCut));
            tapaBaseCSG = tapaBaseCSG.subtract(letraCSGcut);
          } catch (e) {
            console.warn("[tapa] fallo restando shapesLetraForTapa a tapaBaseCSG:", e);
          }
        }
  
        if (idx > 0) {
          const prev = letrasData[idx - 1];
          let prevGeomForBase = new THREE.ExtrudeGeometry(prev.shapesContorno, { depth: TAPA_BASE_DEPTH, bevelEnabled: false });
          prevGeomForBase = toGlobal(prevGeomForBase, prev, 0);
          prevGeomForBase = cleanGeometry(prevGeomForBase);
          try {
            tapaBaseCSG = tapaBaseCSG.subtract(CSG.fromMesh(new THREE.Mesh(prevGeomForBase)));
          } catch (e) {
            console.warn("[tapa] fallo restando prev base:", e);
          }
        }
  
        // Reconstruimos el contorno que vamos a restar: aquí mantenemos el contorno azul
        // pero al añadir holes usamos las shapesLetraForTapa (offsetadas) para que la resta
        // coincida con lo que exportas como tapa.
        if (data.shapesContorno && data.shapesContorno.length) {
          const offsetShapesContorno = offsetPathArray(data.shapesContorno, OFFSET_MM);
  
          const contourShapes = (offsetShapesContorno.length ? offsetShapesContorno : data.shapesContorno).map((cont) => {
            const s = new THREE.Shape(cont.getPoints(SAMPLE_POINTS));
            // Usar shapesLetraForTapa como agujeros (así el corte coincide con la tapa final)
            if (shapesLetraForTapa && shapesLetraForTapa.length) {
              shapesLetraForTapa.forEach((hole) => s.holes.push(new THREE.Path(hole.getPoints(SAMPLE_POINTS))));
            } else if (data.shapesLetra && data.shapesLetra.length) {
              data.shapesLetra.forEach((hole) => s.holes.push(new THREE.Path(hole.getPoints(SAMPLE_POINTS))));
            }
            return s;
          });
  
          let contourGeom = new THREE.ExtrudeGeometry(contourShapes, {
            depth: TAPA_BASE_DEPTH + TAPA_BORDER_DEPTH + 1,
            bevelEnabled: false,
            curveSegments: CURVE_SEGMENTS,
          });
          contourGeom = toGlobal(contourGeom, data, 0);
          contourGeom = cleanGeometry(contourGeom);
  
          const contourMesh = new THREE.Mesh(contourGeom);
          contourMesh.updateMatrix();
          const contourCSG = CSG.fromMesh(contourMesh);
  
          try {
            tapaBaseCSG = tapaBaseCSG.subtract(contourCSG);
            console.debug("[tapa] resta contorno OK para letra:", data.letra);
          } catch (e) {
            console.warn("[tapa] fallo al restar contorno:", e);
          }
        } else {
          console.debug("[tapa] no hay shapesContorno para restar");
        }
  
        // Export
        const tapaResultMesh = CSG.toMesh(tapaBaseCSG, new THREE.Matrix4());
        tapaResultMesh.geometry = cleanGeometry(tapaResultMesh.geometry);
        tapaResultMesh.updateMatrix();
  
        const tmpTapa = new THREE.Mesh(tapaResultMesh.geometry.clone());
        const boxTapa = new THREE.Box3().setFromObject(tmpTapa);
        const centerTapa = boxTapa.getCenter(new THREE.Vector3());
        tmpTapa.geometry.translate(-centerTapa.x, -centerTapa.y, -centerTapa.z);
  
        const stlTapa = exporter.parse(tmpTapa);
        const blobTapa = new Blob([stlTapa], { type: "text/plain" });
        const linkTapa = document.createElement("a");
        linkTapa.href = URL.createObjectURL(blobTapa);
        linkTapa.download = `tapa_resultante_letra_${data.letra}_${idx}.stl`;
        linkTapa.click();
  
      } catch (e) {
        console.error("Error generando tapa resultante para letra", data.letra, e);
      }
  
      // ---------- FIN TAPA RESULTANTE ----------
    });
  };
  
  //-----------------------******
  const descargarSTLPorLetra = (data, idx) => {
    const exporter = new STLExporter();
    const EPS = 0.05;
  
    const toGlobal = (geom, letraData, z = 0) => {
      geom.translate(letraData.posX - letraData.anchoLetra / 2, -letraData.altoTotal / 2, z);
      return geom;
    };

        // helpers 2D para anillos (igual que ya tenías)
        const shapeToRing = (shape, data) => {
          const pts = shape.getPoints(SAMPLE_POINTS);
          const tx = data.posX - data.anchoLetra / 2;
          const ty = -data.altoTotal / 2;
          return pts.map((p) => [p.x + tx, p.y + ty]);
        };
        const shapesToMartinezPolygon = (outerShapes, holesShapesArray, data) => {
          const polygons = [];
          outerShapes.forEach((outerShape) => {
            const outer = shapeToRing(outerShape, data);
            const holes = (holesShapesArray || []).map((h) => shapeToRing(h, data));
            polygons.push([outer, ...holes]);
          });
          return polygons.length === 1 ? polygons[0] : polygons;
        };
        const centroidOfRing = (ring) => {
          let x = 0, y = 0, a = 0;
          for (let i = 0, l = ring.length; i < l; i++) {
            const [x0, y0] = ring[i];
            const [x1, y1] = ring[(i + 1) % l];
            const cross = x0 * y1 - x1 * y0;
            a += cross; x += (x0 + x1) * cross; y += (y0 + y1) * cross;
          }
          a = a * 0.5;
          if (Math.abs(a) < 1e-9) {
            const avg = ring.reduce((acc, p) => [acc[0] + p[0], acc[1] + p[1]], [0, 0]);
            return [avg[0] / ring.length, avg[1] / ring.length];
          }
          return [x / (6 * a), y / (6 * a)];
        };
        const scaleRingAboutCentroid = (ring, margin) => {
          const [cx, cy] = centroidOfRing(ring);
          let sumR = 0;
          for (const [x, y] of ring) sumR += Math.hypot(x - cx, y - cy);
          const avgR = Math.max(1e-6, sumR / ring.length);
          const scale = 1 + margin / avgR;
          return ring.map(([x, y]) => [cx + (x - cx) * scale, cy + (y - cy) * scale]);
        };
  
    // 1) Base y cortes existentes
    let baseGeom = new THREE.ExtrudeGeometry(data.shapesContorno, { depth: BASE_DEPTH, bevelEnabled: false });
    baseGeom = toGlobal(baseGeom, data, 0);
    baseGeom = cleanGeometry(baseGeom);
    let baseCSG = CSG.fromMesh(new THREE.Mesh(baseGeom));
  
    let letraGeom = new THREE.ExtrudeGeometry(data.shapesLetra, { depth: 55, bevelEnabled: false });
    letraGeom = toGlobal(letraGeom, data, 5 + EPS);
    letraGeom = cleanGeometry(letraGeom);
    const letraCSG = CSG.fromMesh(new THREE.Mesh(letraGeom));
    baseCSG = baseCSG.subtract(letraCSG);
  
    if (idx > 0) {
      const prev = letrasData[idx - 1];
      let prevGeomBase = new THREE.ExtrudeGeometry(prev.shapesContorno, { depth: BASE_DEPTH, bevelEnabled: false });
      prevGeomBase = toGlobal(prevGeomBase, prev, 0);
      prevGeomBase = cleanGeometry(prevGeomBase);
      baseCSG = baseCSG.subtract(CSG.fromMesh(new THREE.Mesh(prevGeomBase)));
    }
  
    // 🔽 Aquí se mantienen TODOS tus pasos adicionales:
    // borde interno, duplicado de agujero, anillos, diferencias, etc...
    // (NO LOS MUEVAS, solo déjalos dentro de esta función tal cual los tienes ahora)


    // --- INSERTAR: borde circular alrededor de los agujeros interiores (3mm x 25mm) ---
// pegar justo después de:
//   baseCSG = baseCSG.subtract(letraCSG);
//   (y después de restar prevGeomBase si aplica)

// --- CREAR BORDE INTERNO PARA AGUJEROS (letras tipo A, B, D, O, P, R...) ---
try {
const BORDER_WIDTH_MM = 3;              // ancho del anillo
const BORDER_EXTRUDE_HEIGHT = bordeblancoalto || 25; // altura
const holeRingPaths = [];

// recorrer cada Shape y tomar sus agujeros
(data.shapesLetra || []).forEach((shape) => {
  (shape.holes || []).forEach((holePath) => {
    // convertir hole a Clipper path
    const holeClipperPaths = shapeToClipperPaths(holePath, precisionEscala, 0, 0);
    holeClipperPaths.forEach((p) => {
      // offset positivo = anillo externo al hueco
      const co = new ClipperLib.ClipperOffset();
      co.AddPath(p, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
      const outPaths = [];
      co.Execute(outPaths, BORDER_WIDTH_MM * precisionEscala);

      if (outPaths.length) {
        // restar el hole original del offset para formar el anillo
        const c = new ClipperLib.Clipper();
        c.AddPaths(outPaths, ClipperLib.PolyType.ptSubject, true);
        c.AddPath(p, ClipperLib.PolyType.ptClip, true);
        const ring = new ClipperLib.Paths();
        c.Execute(
          ClipperLib.ClipType.ctDifference,
          ring,
          ClipperLib.PolyFillType.pftNonZero,
          ClipperLib.PolyFillType.pftNonZero
        );

        if (ring.length) holeRingPaths.push(...ring);
      }
    });
  });
});

if (holeRingPaths.length) {
  // convertir Clipper paths → THREE.Shape
  const holeRingShapesThree = clipperPathsToThreeShapes(holeRingPaths, precisionEscala);
  holeRingShapesThree.forEach(
    (s) => s.translate && s.translate(-data.anchoLetra / 2, -data.altoTotal / 2)
  );

  // extruir anillo desde z=0
  const ringExtrudeGeom = new THREE.ExtrudeGeometry(holeRingShapesThree, {
    depth: BORDER_EXTRUDE_HEIGHT,
    bevelEnabled: false,
    curveSegments: CURVE_SEGMENTS,
  });
  const ringGeomGlobal = toGlobal(cleanGeometry(ringExtrudeGeom), data, 0);

  // unir a la base
  const ringCSG = CSG.fromMesh(new THREE.Mesh(ringGeomGlobal));
  baseCSG = baseCSG.union(ringCSG);

  console.debug("[centerBorder] anillo interno creado en letra:", data.letra);
}
} catch (err) {
console.error("[centerBorder] error generando borde interno:", err);
}

// --- FIN INSERTAR ---





// ----------------- DUPLICAR AGUJERO INTERNO Y EXTRUIRLO AL LADO -----------------
// ----------------- DUPLICAR AGUJERO INTERNO Y EXTRUIRLO EN LA MISMA POSICIÓN -----------------
try {
const DUPLICATE_DEPTH = bordeblancoalto + 5 || 25; 
const duplicatePathsAll = [];
const OFFSET_DUPLICATE_MM = 2; // offset en mm para agrandar el duplicado


(data.shapesLetra || []).forEach((shape) => {
  (shape.holes || []).forEach((holePath) => {
    const holePts = holePath.getPoints(SAMPLE_POINTS).map(p => ({
      X: Math.round(p.x * precisionEscala),
      Y: Math.round(p.y * precisionEscala),
    }));

    if (holePts.length > 2) {
      const co = new ClipperLib.ClipperOffset();
      co.AddPath(holePts, ClipperLib.JoinType.jtMiter, ClipperLib.EndType.etClosedPolygon);

      const offsetPaths = new ClipperLib.Paths();
      co.Execute(offsetPaths, OFFSET_DUPLICATE_MM  * precisionEscala);

      if (offsetPaths.length) {
        offsetPaths.forEach(p => duplicatePathsAll.push(p));
      }
    }
  });
});

if (duplicatePathsAll.length) {
  const duplicateShapes = clipperPathsToThreeShapes(duplicatePathsAll, precisionEscala);

  // trasladar cada shape al sistema local de la letra
  duplicateShapes.forEach(s => {
    if (s.translate) s.translate(-data.anchoLetra / 2, -data.altoTotal / 2);
  });

  // crear extrusión de la copia
  let dupGeom = new THREE.ExtrudeGeometry(duplicateShapes, {
    depth: DUPLICATE_DEPTH,
    bevelEnabled: false,
    curveSegments: CURVE_SEGMENTS || 16,
  });
  dupGeom = cleanGeometry(dupGeom);

  // ✅ mismo toGlobal que la letra original, sin mover al costado
  const dupGlobal = toGlobal(dupGeom, data, 0);

  // unir al CSG de la base
  const dupCSG = CSG.fromMesh(new THREE.Mesh(dupGlobal));
  baseCSG = baseCSG.union(dupCSG);

  console.debug("[duplicateHole] copia del agujero superpuesta en letra:", data.letra);
} else {
  console.debug("[duplicateHole] no se detectaron agujeros en letra:", data.letra);
}
} catch (errDup) {
console.error("[duplicateHole] error generando copia del agujero:", errDup);
}
// ----------------- FIN DUPLICADO AGUJERO -----------------

// ----------------- FIN DUPLICADO AGUJERO -----------------



    



    // 2) Anillo blanco (y su parche por intersección, como ya tenías)
    const anilloShapes = data.shapesContorno.map((cont) => {
      const s = new THREE.Shape(cont.getPoints(SAMPLE_POINTS));
      data.shapesBordeNegro.forEach((h) => s.holes.push(new THREE.Path(h.getPoints(SAMPLE_POINTS))));
      return s;
    });
    let anilloGeom = new THREE.ExtrudeGeometry(anilloShapes, { depth: bordeblancoalto, bevelEnabled: false });
    anilloGeom = toGlobal(anilloGeom, data, 5 + EPS);
    anilloGeom = cleanGeometry(anilloGeom);
    let anilloCSG = CSG.fromMesh(new THREE.Mesh(anilloGeom));

    if (idx > 0) {
      const prev = letrasData[idx - 1];
      let prevGeomRing = new THREE.ExtrudeGeometry(prev.shapesContorno, { depth: bordeblancoalto, bevelEnabled: false });
      prevGeomRing = toGlobal(prevGeomRing, prev, 5 + EPS);
      prevGeomRing = cleanGeometry(prevGeomRing);
      anilloCSG = anilloCSG.subtract(CSG.fromMesh(new THREE.Mesh(prevGeomRing)));

      try {
        // ---- 1) poligonos en COORD global (shapeToRing ya aplica tx,ty) ----
        const currPoly = shapesToMartinezPolygon(data.shapesContorno, [], data);
        const prevPoly = shapesToMartinezPolygon(prev.shapesContorno, [], prev);
      
        // intersection = zona que se RESTA (el hueco actual). Puede ser polygon o multipolygon
        const inter = martinez.intersection(currPoly, prevPoly);
        if (!inter) {
          console.debug("[borde] no hay intersección entre", data.letra, "y", prev.letra);
        }
      
        // ---- 2) extraer rings exteriores desde martinez (normalize) ----
        const extractRings = (m) => {
          const rings = [];
          if (!m || !Array.isArray(m)) return rings;
          // martinez puede devolver polygon [ring, hole..] o multipolygon [[[ring,...]], ...]
          const walk = (obj) => {
            if (!Array.isArray(obj)) return;
            const first = obj[0];
            if (first && typeof first[0] === "number") {
              // aquí obj es ring (lista de puntos), lo tomamos como outer ring
              rings.push(obj);
              return;
            }
            for (const child of obj) walk(child);
          };
          walk(m);
          return rings;
        };
        const cutRings = extractRings(inter || []);
        console.debug("[borde] cutRings:", cutRings.length, "letter:", data.letra);
      

const BORDER_DEPTH = 21;            // altura a extruir desde z=0
const VERT_ROUND_EPS = 1e-4;        // precisión para agrupar vértices (ajustar si hace falta)
const MIN_LOOP_VERTS = 6;           // mínimo puntos para considerar un loop válido
const CURVE_SEGMENTS = 16;          // suavidad de la extrusión

// helper: string key para un vértice con redondeo
const vKey = (x, y, z) => {
const rx = Math.round(x / VERT_ROUND_EPS) * VERT_ROUND_EPS;
const ry = Math.round(y / VERT_ROUND_EPS) * VERT_ROUND_EPS;
const rz = Math.round(z / VERT_ROUND_EPS) * VERT_ROUND_EPS;
return `${rx.toFixed(6)}|${ry.toFixed(6)}|${rz.toFixed(6)}`;
};

// helper: extraer aristas límite (edges con count==1) de una geometría BufferGeometry
const extractBoundaryEdges = (geom) => {
const posAttr = geom.attributes.position;
if (!posAttr) return [];
const pos = posAttr.array;
const idxAttr = geom.index ? geom.index.array : null;

// map coordKey -> vertex index (unique)
const vertMap = new Map();
const verts = []; // list of coordinate arrays by id

const getOrCreateVertexId = (x, y, z) => {
  const k = vKey(x, y, z);
  if (vertMap.has(k)) return vertMap.get(k);
  const id = verts.length;
  verts.push([x, y, z]);
  vertMap.set(k, id);
  return id;
};

const edgeCount = new Map(); // key "minId_maxId" -> count
const edgeCoords = new Map(); // key -> [ [x1,y1,z1], [x2,y2,z2] ]

const triCount = idxAttr ? idxAttr.length / 3 : pos.length / 9;
for (let t = 0; t < triCount; t++) {
  let aIdx, bIdx, cIdx;
  if (idxAttr) {
    aIdx = idxAttr[t * 3] * 3;
    bIdx = idxAttr[t * 3 + 1] * 3;
    cIdx = idxAttr[t * 3 + 2] * 3;
  } else {
    aIdx = t * 9;
    bIdx = aIdx + 3;
    cIdx = aIdx + 6;
  }
  const ax = pos[aIdx], ay = pos[aIdx + 1], az = pos[aIdx + 2];
  const bx = pos[bIdx], by = pos[bIdx + 1], bz = pos[bIdx + 2];
  const cx = pos[cIdx], cy = pos[cIdx + 1], cz = pos[cIdx + 2];

  const va = getOrCreateVertexId(ax, ay, az);
  const vb = getOrCreateVertexId(bx, by, bz);
  const vc = getOrCreateVertexId(cx, cy, cz);

  const edgesTri = [[va, vb, [ax, ay, az, bx, by, bz]], [vb, vc, [bx, by, bz, cx, cy, cz]], [vc, va, [cx, cy, cz, ax, ay, az]]];
  for (const [v1, v2, coords] of edgesTri) {
    const a = Math.min(v1, v2), b = Math.max(v1, v2);
    const k = `${a}_${b}`;
    const prev = edgeCount.get(k) || 0;
    edgeCount.set(k, prev + 1);
    if (!edgeCoords.has(k)) {
      // store the original coords for the segment (use the rounded vertex positions)
      const p1 = verts[a];
      const p2 = verts[b];
      edgeCoords.set(k, [[p1[0], p1[1], p1[2]], [p2[0], p2[1], p2[2]]]);
    }
  }
}

// boundary edges are those with count == 1
const boundaries = [];
for (const [k, cnt] of edgeCount.entries()) {
  if (cnt === 1) {
    const coords = edgeCoords.get(k);
    if (coords) boundaries.push(coords);
  }
}
return boundaries; // array of [ [x1,y1,z1], [x2,y2,z2] ]
};

// -------------- reconstruir base original y base después de resta --------------
const baseGeomOriginal = new THREE.ExtrudeGeometry(data.shapesContorno, { depth: BASE_DEPTH, bevelEnabled: false });
toGlobal(baseGeomOriginal, data, 0);
const baseOrigMesh = new THREE.Mesh(cleanGeometry(baseGeomOriginal));

const baseAfterMesh = CSG.toMesh(baseCSG, new THREE.Matrix4());
baseAfterMesh.geometry = cleanGeometry(baseAfterMesh.geometry);

// extraer edges boundary de ambas
const origBoundEdges = extractBoundaryEdges(baseOrigMesh.geometry);
const afterBoundEdges = extractBoundaryEdges(baseAfterMesh.geometry);

// crear set de claves para after edges (por coordenadas redondeadas)
const edgeKeyFromCoords = (c) => {
const [a, b] = c;
const ka = vKey(a[0], a[1], a[2]);
const kb = vKey(b[0], b[1], b[2]);
return ka < kb ? `${ka}|${kb}` : `${kb}|${ka}`;
};
const afterSet = new Set(afterBoundEdges.map(edgeKeyFromCoords));

// filtrar edges que están en orig pero no en after => esos son los cortes
const diffEdges = origBoundEdges.filter(e => !afterSet.has(edgeKeyFromCoords(e)));
console.debug("[bordeDiff] origBoundEdges:", origBoundEdges.length, "afterBoundEdges:", afterBoundEdges.length, "diffEdges:", diffEdges.length, "letter:", data.letra);

// si no hay diffEdges -> debug y salir
if (!diffEdges.length) {
console.debug("[bordeDiff] no se detectaron segmentos de corte por diferencia de aristas para", data.letra, " - intenta ajustar VERT_ROUND_EPS");
} else {
// construir mapa de conectividad para ensamblar loops
const adj = new Map(); // key vertex -> Set(neighbors)
const coordMap = new Map(); // key -> [x,y,z]

const ensureVert = (v) => {
  const k = vKey(v[0], v[1], v[2]);
  if (!coordMap.has(k)) coordMap.set(k, [v[0], v[1], v[2]]);
  if (!adj.has(k)) adj.set(k, new Set());
  return k;
};

for (const seg of diffEdges) {
  const [a, b] = seg;
  const ka = ensureVert(a);
  const kb = ensureVert(b);
  adj.get(ka).add(kb);
  adj.get(kb).add(ka);
}

// construir loops por recorrido greedily
const visited = new Set();
const loops = [];
for (const start of adj.keys()) {
  if (visited.has(start)) continue;
  let cur = start;
  let prev = null;
  const chain = [cur];
  visited.add(cur);
  // intentar seguir hasta cerrar
  while (true) {
    const neigh = Array.from(adj.get(cur) || []).filter(n => n !== prev);
    if (!neigh.length) break;
    // preferir vecino no visitado
    let next = neigh.find(n => !visited.has(n)) || neigh[0];
    if (next === start) {
      chain.push(next);
      visited.add(next);
      break;
    }
    if (visited.has(next)) {
      // evitar bucle infinito
      break;
    }
    chain.push(next);
    visited.add(next);
    prev = cur;
    cur = next;
    if (chain.length > 20000) break;
  }
  // cerrada?
  if (chain.length >= MIN_LOOP_VERTS && chain[chain.length - 1] === start) {
    // convertir a puntos 2D y calcular area
    const pts2 = chain.slice(0, -1).map(k => {
      const p = coordMap.get(k);
      return [p[0], p[1]];
    });
    // area simple
    const area = Math.abs(pts2.reduce((acc, p, i) => {
      const q = pts2[(i + 1) % pts2.length];
      return acc + p[0] * q[1] - q[0] * p[1];
    }, 0) * 0.5);
    if (area > 1e-6) loops.push({ pts: pts2, area });
  }
}

console.debug("[bordeDiff] boundary loops count:", loops.length, "letter:", data.letra);

if (!loops.length) {
  console.debug("[bordeDiff] no se detectaron loops cerrados válidos, tal vez ajustar VERT_ROUND_EPS o MIN_LOOP_VERTS");
} else {
  // escoger loop más grande y generar shape
  loops.sort((a, b) => b.area - a.area);
  const best = loops[0].pts;
  // asegurar orientación CCW
  const signedArea = best.reduce((acc, p, i) => {
    const q = best[(i + 1) % best.length];
    return acc + p[0] * q[1] - q[0] * p[1];
  }, 0) * 0.5;
  if (signedArea < 0) best.reverse();

  const shapeVecs = best.map(([x, y]) => new THREE.Vector2(x, y));
  const shape = new THREE.Shape(shapeVecs);
  // extruir borde desde z=0
  let bordeGeom = null;
  try {
    bordeGeom = new THREE.ExtrudeGeometry(shape, { depth: BORDER_DEPTH, bevelEnabled: false, curveSegments: CURVE_SEGMENTS });
    bordeGeom = cleanGeometry(bordeGeom);
  } catch (e) {
    console.warn("[bordeDiff] extrusión fallo:", e);
    bordeGeom = null;
  }

  if (bordeGeom && bordeGeom.attributes && bordeGeom.attributes.position && bordeGeom.attributes.position.count >= 10) {
    const bordeMesh = new THREE.Mesh(bordeGeom);
    bordeMesh.updateMatrix();
    try {
      const bordeCSG = CSG.fromMesh(bordeMesh);
      baseCSG = baseCSG.union(bordeCSG);
      console.debug("[bordeDiff] union OK en base para letra:", data.letra);
    } catch (e) {
      console.warn("[bordeDiff] fallo CSG.fromMesh/union:", e);
    }
  } else {
    console.debug("[bordeDiff] bordeGeom inválido o degenerado, no se unió.");
  }
}
}
// === FIN BLOQUE ===



        
      } catch (err) {
        console.error("Error generando borde desde base:", err);
      }
      
      
      
    }

    // 3) === RESTAR CANALES INTERNOS DE ESTE LETRERO ===
    // 3) === RESTAR CANALES INTERNOS DE ESTE LETRERO ===
    if (rects.length) {
      // seguridad: que CHANNEL_Z quede dentro del sólido y deje piel arriba/abajo
      const minZ = WALL_THICKNESS_TOP_BOTTOM; // mínimo desde la base
      const maxZ = Math.max(0, BASE_DEPTH - WALL_THICKNESS_TOP_BOTTOM - CHANNEL_DEPTH);
      const safeChannelZ = Math.min(Math.max(CHANNEL_Z, minZ), maxZ);

      rects.forEach((r) => {
        // Crear el canal usando la misma referencia de coordenadas que las extrusiones:
        const canalGeom = new THREE.BoxGeometry(r.w, r.h, CHANNEL_DEPTH);
        // traducimos la geometría igual que a las extrusiones: toGlobal(geom, data, z)
        // NOTA: no usamos 'canalMesh.position' sino la propia geometría para mantener el mismo espacio
  // si cada rect tiene su propio nivel Z (r.Z o r.z), úsalo
const zNivel = (r.Z ?? r.z ?? safeChannelZ);
canalGeom.translate(r.x, r.y, zNivel + CHANNEL_DEPTH / 2);


        // limpiar/optimizar un poco antes de CSG (opcional)
        const canalGeomClean = cleanGeometry(canalGeom);

        const canalMesh = new THREE.Mesh(canalGeomClean);
        canalMesh.updateMatrix(); // importante para que CSG lea la posición/matriz correcta

        const canalCSG = CSG.fromMesh(canalMesh);
        baseCSG = baseCSG.subtract(canalCSG);
        anilloCSG = anilloCSG.subtract(canalCSG);
      });
    }


    if (idx > 0) {
      const prev = letrasData[idx - 1];
      let prevGeomRing = new THREE.ExtrudeGeometry(prev.shapesContorno, { depth: bordeblancoalto, bevelEnabled: false });
      prevGeomRing = toGlobal(prevGeomRing, prev, 5 + EPS);
      prevGeomRing = cleanGeometry(prevGeomRing);
      anilloCSG = anilloCSG.subtract(CSG.fromMesh(new THREE.Mesh(prevGeomRing)));

      // ... tu lógica martinez/intersection/cutRings aquí ...
    }

    // ------------------ INSERTAR AQUÍ: extrudir anillo naranja ------------------

    if (data.shapesNaranja && data.shapesNaranja.length > 0) {
      try {
        // Creamos extrusión a partir de shapesNaranja (ya son THREE.Shape)
        // Si tus shapesNaranja incluyen holes, extrude debe manejarlas bien porque son Shape con paths.
        const orangeShapesForExtrude = data.shapesNaranja.map((s) => {
          // Asegurarnos de reconstruir shape con puntos para evitar referencias raras
          return new THREE.Shape(s.getPoints(SAMPLE_POINTS));
        });

        let orangeGeom = new THREE.ExtrudeGeometry(orangeShapesForExtrude, {
          depth: ORANGE_DEPTH,
          bevelEnabled: false,
          curveSegments: CURVE_SEGMENTS,
        });

        // misma cota z que el anillo blanco
        orangeGeom = toGlobal(orangeGeom, data, 5 + EPS);
        orangeGeom = cleanGeometry(orangeGeom);

        // CSG del anillo naranja
        let orangeCSG = CSG.fromMesh(new THREE.Mesh(orangeGeom));


        // --- APLICAR CORTES (rects) TAMBIÉN AL ANILLO NARANJA ---
if (rects && rects.length) {
// recalcular safeChannelZ (mismo cálculo que usaste antes)
const minZ = WALL_THICKNESS_TOP_BOTTOM;
const maxZ = Math.max(0, BASE_DEPTH - WALL_THICKNESS_TOP_BOTTOM - CHANNEL_DEPTH);
const safeChannelZ = Math.min(Math.max(CHANNEL_Z, minZ), maxZ);

rects.forEach((r) => {
  // crear canal con la misma referencia de coordenadas que las extrusiones
  const canalGeomOrange = new THREE.BoxGeometry(r.w, r.h, CHANNEL_DEPTH);
  canalGeomOrange.translate(r.x, r.y, safeChannelZ + CHANNEL_DEPTH / 2);

  const canalGeomCleanOrange = cleanGeometry(canalGeomOrange);
  const canalMeshOrange = new THREE.Mesh(canalGeomCleanOrange);
  canalMeshOrange.updateMatrix();

  const canalCSGOrange = CSG.fromMesh(canalMeshOrange);

  // restar el canal del orangeCSG para que el hueco se aplique al contorno naranja
  try {
    orangeCSG = orangeCSG.subtract(canalCSGOrange);
  } catch (e) {
    console.warn("[export] fallo restando canal a orangeCSG:", e);
  }
});
}
// ----------------------------------------------------------------



        // Si existe la letra previa: recortamos igual que el anillo blanco para evitar solapados
        if (idx > 0) {
          const prev = letrasData[idx - 1];
          let prevGeomRingForOrange = new THREE.ExtrudeGeometry(prev.shapesContorno, { depth: ORANGE_DEPTH, bevelEnabled: false });
          prevGeomRingForOrange = toGlobal(prevGeomRingForOrange, prev, 5 + EPS);
          prevGeomRingForOrange = cleanGeometry(prevGeomRingForOrange);
          orangeCSG = orangeCSG.subtract(CSG.fromMesh(new THREE.Mesh(prevGeomRingForOrange)));
        }

        // Unir el naranja con el anillo blanco (si prefieres separarlo, haz union con baseCSG)
        try {
          anilloCSG = anilloCSG.union(orangeCSG);
          console.debug("[export] orange union OK letter:", data.letra);
        } catch (e) {
          console.warn("[export] fallo al unir orange/anillo:", e);
          // fallback: unir a baseCSG si union con anillo falla
          try {
            baseCSG = baseCSG.union(orangeCSG);
            console.debug("[export] orange unido a baseCSG como fallback para:", data.letra);
          } catch (e2) {
            console.error("[export] no se pudo unir orange a ninguna CSG:", e2);
          }
        }
      } catch (errOrange) {
        console.error("[export] fallo extruir orange para letra", data.letra, errOrange);
      }
    }
    // ---------------------------------------------------------------------------







// ---- Exportar a STL (con merge y centrado) ----
const baseMesh = CSG.toMesh(baseCSG, new THREE.Matrix4());
const ringMesh = CSG.toMesh(anilloCSG, new THREE.Matrix4());
baseMesh.geometry = cleanGeometry(baseMesh.geometry);
ringMesh.geometry = cleanGeometry(ringMesh.geometry);

baseMesh.updateMatrix();
ringMesh.updateMatrix();

// Merge geometrías
let merged = mergeBufferGeometries(
  [
    baseMesh.geometry.clone().applyMatrix4(baseMesh.matrix),
    ringMesh.geometry.clone().applyMatrix4(ringMesh.matrix),
  ],
  false
);
merged = cleanGeometry(merged);

// Centrar en el origen
const tmp = new THREE.Mesh(merged);
const box = new THREE.Box3().setFromObject(tmp);
const center = box.getCenter(new THREE.Vector3());
tmp.geometry.translate(-center.x, -center.y, -center.z);

// Exportar
const stlString = exporter.parse(tmp);
const blob = new Blob([stlString], { type: "text/plain" });
const link = document.createElement("a");
link.href = URL.createObjectURL(blob);
link.download = `letra_${data.letra}_${idx}.stl`;
link.click();

  };
// Reemplaza/pega esto en tu componente (asegúrate de eliminar o renombrar la función antigua)
// Refactor de descargarTapaSTLPorLetra - mantiene la lógica original pero más modular y limpio
const descargarTapaSTLPorLetra = (data, idx) => {
  const exporter = new STLExporter();
  const EPS = 0.05;
  const OFFSET_EXTERNO = -0.6;
  const CLIPPER_SCALE = precisionEscala || 1000;
  const SAMPLE = SAMPLE_POINTS || 12;

  // ---------------- HELPERS UTILES ----------------
  const toGlobal = (geom, d, z = 0) => {
    geom.translate(d.posX - d.anchoLetra / 2, -d.altoTotal / 2, z);
    return geom;
  };

  const safeNumber = (v, fallback = 0) => (typeof v === 'number' ? v : fallback);

  // Convierte array THREE.Vector2-like a path clipper y viceversa
  const ptsToClipper = (pts) => pts.map(p => ({ X: Math.round(p.x * CLIPPER_SCALE), Y: Math.round(p.y * CLIPPER_SCALE) }));
  const pathToShape = (path) => {
    const pts = path.map(p => new THREE.Vector2(p.X / CLIPPER_SCALE, p.Y / CLIPPER_SCALE));
    return new THREE.Shape(pts);
  };

  // normaliza cualquier shape/path para CSG
  const normalizeShapeForCSG_local = (shapeOrPath, opts = {}) => {
    const SAMPLE_LOCAL = opts.samplePoints || SAMPLE;
    let pts = [];
    try {
      pts = shapeOrPath.getPoints ? shapeOrPath.getPoints(SAMPLE_LOCAL) : shapeOrPath;
    } catch (e) {
      if (Array.isArray(shapeOrPath)) pts = shapeOrPath;
      else pts = [];
    }
    if (!pts || pts.length < 3) return new THREE.Shape([]);
    // transform to Vector2 array
    pts = pts.map(p => (p.x !== undefined ? new THREE.Vector2(p.x, p.y) : new THREE.Vector2(p[0], p[1])));
    // reuse tus funciones: uniqueConsecutivePoints, removeCollinear, clipperCleanPath, ensureCCW
    const uniqueConsecutivePoints = (points, eps = 1e-5) => {
      if (!points || !points.length) return [];
      const out = [points[0]];
      for (let i = 1; i < points.length; i++) {
        const a = points[i - 1], b = points[i];
        if (Math.hypot(b.x - a.x, b.y - a.y) > eps) out.push(b);
      }
      if (out.length > 1) {
        const first = out[0], last = out[out.length - 1];
        if (Math.hypot(last.x - first.x, last.y - first.y) < eps) out[out.length - 1] = first;
      }
      return out;
    };
    const removeCollinear = (points, eps = 1e-8) => {
      if (!points || points.length < 3) return points.slice();
      const out = [];
      for (let i = 0; i < points.length; i++) {
        const a = points[(i - 1 + points.length) % points.length];
        const b = points[i];
        const c = points[(i + 1) % points.length];
        const cross = (b.x - a.x) * (c.y - b.y) - (b.y - a.y) * (c.x - b.x);
        if (Math.abs(cross) > eps) out.push(b);
      }
      return out.length ? out : points.slice();
    };
    const ensureCCW = (points) => {
      let a = 0;
      for (let i = 0; i < points.length; i++) {
        const p0 = points[i], p1 = points[(i + 1) % points.length];
        a += p0.x * p1.y - p1.x * p0.y;
      }
      return a < 0 ? points.slice().reverse() : points;
    };
    const clipperCleanPathLocal = (pointsArr, cleanOffsetMm = 0.05) => {
      if (typeof ClipperLib === "undefined" || !pointsArr || pointsArr.length < 3) return null;
      try {
        const path = pointsArr.map(p => ({ X: Math.round(p.x * CLIPPER_SCALE), Y: Math.round(p.y * CLIPPER_SCALE) }));
        const co1 = new ClipperLib.ClipperOffset();
        co1.AddPath(path, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
        const sol1 = new ClipperLib.Paths();
        co1.Execute(sol1, Math.round(cleanOffsetMm * CLIPPER_SCALE));
        if (!sol1 || sol1.length === 0) return null;
        const co2 = new ClipperLib.ClipperOffset();
        sol1.forEach(pth => co2.AddPath(pth, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon));
        const sol2 = new ClipperLib.Paths();
        co2.Execute(sol2, -Math.round(cleanOffsetMm * CLIPPER_SCALE));
        if (!sol2 || sol2.length === 0) return null;
        return sol2[0].map(pt => ({ x: pt.X / CLIPPER_SCALE, y: pt.Y / CLIPPER_SCALE }));
      } catch (err) {
        console.warn("[normalize] fallo clipperCleanPath:", err);
        return null;
      }
    };

    let cleaned = uniqueConsecutivePoints(pts, 1e-5);
    if (cleaned.length < 3) return new THREE.Shape(cleaned);
    cleaned = removeCollinear(cleaned, 1e-9);
    if (cleaned.length < 3) return new THREE.Shape(cleaned);
    const cleanedByClipper = clipperCleanPathLocal(cleaned, 0.05) || clipperCleanPathLocal(cleaned, 0.2) || null;
    let finalPts = cleanedByClipper && cleanedByClipper.length >= 3 ? cleanedByClipper.map(p => new THREE.Vector2(p.x, p.y)) : cleaned;
    finalPts = ensureCCW(finalPts);
    return new THREE.Shape(finalPts);
  };

  // ----------------- CLIPPER / OFFSET -----------------
  const offsetTHREEShapeOrPath_local = (shapeOrPath, deltaMm) => {
    let pts = [];
    try {
      pts = shapeOrPath.getPoints ? shapeOrPath.getPoints(SAMPLE) : shapeOrPath;
    } catch (e) {
      if (Array.isArray(shapeOrPath)) pts = shapeOrPath;
      else pts = [];
    }
    if (typeof ClipperLib !== "undefined") {
      const p = pts.map(pt => ({ X: Math.round(pt.x * CLIPPER_SCALE), Y: Math.round(pt.y * CLIPPER_SCALE) }));
      const co = new ClipperLib.ClipperOffset();
      co.AddPath(p, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
      const sol = new ClipperLib.Paths();
      co.Execute(sol, Math.round(deltaMm * CLIPPER_SCALE));
      if (sol && sol.length) return sol.map(path => pathToShape(path));
      return [];
    }
    // Fallback: approximate scale about center
    if (!pts || pts.length === 0) return [];
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    pts.forEach(p => { minX = Math.min(minX, p.x); minY = Math.min(minY, p.y); maxX = Math.max(maxX, p.x); maxY = Math.max(maxY, p.y); });
    const width = maxX - minX, height = maxY - minY, centerX = (minX + maxX) / 2, centerY = (minY + maxY) / 2;
    const avgDim = Math.max(width, height) || 1;
    const scale = Math.max(0.01, (avgDim + 2 * deltaMm) / avgDim);
    const scaledPts = pts.map(p => new THREE.Vector2(centerX + (p.x - centerX) * scale, centerY + (p.y - centerY) * scale));
    return [new THREE.Shape(scaledPts)];
  };

  const offsetPathArray_local = (pathsArray, deltaMm) => {
    const out = [];
    if (!pathsArray || !pathsArray.length) return out;
    pathsArray.forEach(p => {
      const res = offsetTHREEShapeOrPath_local(p, deltaMm);
      if (res && res.length) res.forEach(s => out.push(s));
    });
    return out;
  };

  // ----------------- OPERACIONES CSG/GEOMETRIA UTILES -----------------
  const extrudeToCSG = (shapes, depth, z = 0, opts = {}) => {
    try {
      const geo = new THREE.ExtrudeGeometry(shapes, { depth: depth, bevelEnabled: false, curveSegments: opts.curveSegments || CURVE_SEGMENTS });
      toGlobal(geo, data, z);
      const cleaned = cleanGeometry(geo);
      const mesh = new THREE.Mesh(cleaned);
      mesh.updateMatrix();
      return CSG.fromMesh(mesh);
    } catch (e) {
      console.error("[extrudeToCSG] fallo extruir -> CSG:", e);
      return null;
    }
  };

  const subtractChannels = (targetCSG, rectsList, dataLocal, depthForChannel) => {
    if (!rectsList || !rectsList.length) return targetCSG;
    const minZ = WALL_THICKNESS_TOP_BOTTOM;
    const maxZ = Math.max(0, BASE_DEPTH - WALL_THICKNESS_TOP_BOTTOM - CHANNEL_DEPTH);
    const safeChannelZ = Math.min(Math.max(CHANNEL_Z, minZ), maxZ);
    rectsList.forEach((r) => {
      const canalGeom = new THREE.BoxGeometry(r.w, r.h, depthForChannel || CHANNEL_DEPTH);
      canalGeom.translate(r.x, r.y, safeChannelZ + (depthForChannel || CHANNEL_DEPTH) / 2);
      const canalClean = cleanGeometry(canalGeom);
      const canalMesh = new THREE.Mesh(canalClean);
      canalMesh.updateMatrix();
      const canalCSG = CSG.fromMesh(canalMesh);
      try { targetCSG = targetCSG.subtract(canalCSG); } catch (e) { console.warn("[subtractChannels] fallo resta canal:", e); }
    });
    return targetCSG;
  };

  const subtractPreviousIfAny = (targetCSG, prevData, depth, zOffset = 0) => {
    if (!prevData) return targetCSG;
    try {
      // 1) obtenemos los contornos previos trasladados (paths int) en cooordenadas clipper
      const prevPaths = (prevData.shapesContorno || []).map(s => {
        const pts = s.getPoints(SAMPLE).map(p => ({ X: Math.round((p.x + (prevData.posX - prevData.anchoLetra/2)) * CLIPPER_SCALE), Y: Math.round((p.y + (-prevData.altoTotal/2)) * CLIPPER_SCALE) }));
        return pts;
      }).filter(p => p && p.length > 2);
  
      // 2) obtenemos las paths del contorno actual (subject)
      const currPaths = (data.shapesContorno || []).map(s => {
        const pts = s.getPoints(SAMPLE).map(p => ({ X: Math.round((p.x + (data.posX - data.anchoLetra/2)) * CLIPPER_SCALE), Y: Math.round((p.y + (-data.altoTotal/2)) * CLIPPER_SCALE) }));
        return pts;
      }).filter(p => p && p.length > 2);
  
      if (!prevPaths.length || !currPaths.length) return targetCSG;
  
      // 3) Intersección Clipper entre prevPaths y currPaths -> solo la zona superpuesta
      const c = new ClipperLib.Clipper();
      c.AddPaths(prevPaths, ClipperLib.PolyType.ptSubject, true);
      c.AddPaths(currPaths, ClipperLib.PolyType.ptClip, true);
      const interRes = new ClipperLib.Paths();
      c.Execute(ClipperLib.ClipType.ctIntersection, interRes, ClipperLib.PolyFillType.pftEvenOdd, ClipperLib.PolyFillType.pftEvenOdd);
  
      if (!interRes || !interRes.length) return targetCSG;
  
      // 4) convert interRes a Shape -> extrude -> restar
      const interShapes = interRes.map(path => {
        const pts = path.map(pt => new THREE.Vector2(pt.X / CLIPPER_SCALE - (data.posX - data.anchoLetra/2), pt.Y / CLIPPER_SCALE - (-data.altoTotal/2)));
        return new THREE.Shape(pts);
      });
  
      let prevGeom = new THREE.ExtrudeGeometry(interShapes, { depth, bevelEnabled: false });
      prevGeom = toGlobal(prevGeom, data, zOffset); // coloca en sitio correcto
      prevGeom = cleanGeometry(prevGeom);
      const prevMesh = new THREE.Mesh(prevGeom);
      prevMesh.updateMatrix();
      const prevCSG = CSG.fromMesh(prevMesh);
  
      return targetCSG.subtract(prevCSG);
    } catch (e) {
      console.warn("[subtractPreviousIfAny] fallo prev subtraction:", e);
      return targetCSG;
    }
  };
  

  // ---- generar agujeros automáticos (tu función original con nombre local) ----
  function generarAgujerosCirculares_local(shape, radioMm, spacingMm) {
    const box = new THREE.Box3().setFromPoints(shape.getPoints(50));
    const min = box.min, max = box.max;
    const agujeros = [];
    for (let x = min.x; x <= max.x; x += spacingMm) {
      for (let y = min.y; y <= max.y; y += spacingMm) {
        const p = new THREE.Vector2(x, y);
        if (shape.containsPoint(p)) {
          const circleShape = new THREE.Shape();
          circleShape.absarc(x, y, radioMm, 0, Math.PI * 2, false);
          agujeros.push(circleShape);
        }
      }
    }
    return agujeros;
  }

  // ---------------- INICIO PIPELINE (mantener tu lógica) ----------------
  try {
    // Ajustar shapes con offset externo (si aplica)
    const adjustedShapesLetra = data.shapesLetra && data.shapesLetra.length ? offsetPathArray_local(data.shapesLetra, OFFSET_EXTERNO) : [];
    const shapesLetraForTapa = adjustedShapesLetra.length ? adjustedShapesLetra : (data.shapesLetra || []);

    const adjustedShapesNaranja = data.shapesNaranja && data.shapesNaranja.length ? offsetPathArray_local(data.shapesNaranja, OFFSET_EXTERNO) : [];
    const shapesNaranjaForTapa = adjustedShapesNaranja.length ? adjustedShapesNaranja : (data.shapesNaranja || []);

    // Build baseShapesForTapa (same)
    const baseShapesForTapa = [];
    if (shapesLetraForTapa && shapesLetraForTapa.length) shapesLetraForTapa.forEach(s => baseShapesForTapa.push(new THREE.Shape(s.getPoints(SAMPLE))));
    if (shapesNaranjaForTapa && shapesNaranjaForTapa.length) shapesNaranjaForTapa.forEach(s => baseShapesForTapa.push(new THREE.Shape(s.getPoints(SAMPLE))));

    // 1) Base y cortes existentes
    let baseGeom = new THREE.ExtrudeGeometry(data.shapesContorno, { depth: BASE_DEPTH, bevelEnabled: false });
    baseGeom = toGlobal(baseGeom, data, 0);
    baseGeom = cleanGeometry(baseGeom);
    let baseCSG = CSG.fromMesh(new THREE.Mesh(baseGeom));

    // Extruir letra y restar de base
    let letraGeom = new THREE.ExtrudeGeometry(data.shapesLetra, { depth: 55, bevelEnabled: false });
    letraGeom = toGlobal(letraGeom, data, 5 + EPS);
    letraGeom = cleanGeometry(letraGeom);
    const letraCSG = CSG.fromMesh(new THREE.Mesh(letraGeom));
    baseCSG = baseCSG.subtract(letraCSG);

    // Si hay anterior (tapas2Data), restar
    if (idx > 0) {
      baseCSG = subtractPreviousIfAny(baseCSG, tapas2Data[idx - 1], BASE_DEPTH, 0);
    }

    // 2) Anillo blanco
    const anilloShapes = data.shapesContorno.map((cont) => {
      const s = new THREE.Shape(cont.getPoints(SAMPLE));
      (data.shapesBordeNegro || []).forEach((h) => s.holes.push(new THREE.Path(h.getPoints(SAMPLE))));
      return s;
    });
    let anilloGeom = new THREE.ExtrudeGeometry(anilloShapes, { depth: bordeblancoalto, bevelEnabled: false });
    anilloGeom = toGlobal(anilloGeom, data, 5 + EPS);
    anilloGeom = cleanGeometry(anilloGeom);
    let anilloCSG = CSG.fromMesh(new THREE.Mesh(anilloGeom));

    if (idx > 0) {
      anilloCSG = subtractPreviousIfAny(anilloCSG, tapas2Data[idx - 1], bordeblancoalto, 5 + EPS);
      // Intento de martinez intersection como en tu bloque original
      try {
        const shapesToMartinezPolygon = (outerShapes, holesArray, dLocal) => {
          const polygons = [];
          outerShapes.forEach((outerShape) => {
            const outer = outerShape.getPoints(SAMPLE).map(p => [p.x + (dLocal.posX - dLocal.anchoLetra / 2), p.y + (-dLocal.altoTotal / 2)]);
            const holes = (holesArray || []).map(h => h.getPoints(SAMPLE).map(p => [p.x + (dLocal.posX - dLocal.anchoLetra / 2), p.y + (-dLocal.altoTotal / 2)]));
            polygons.push([outer, ...holes]);
          });
          return polygons.length === 1 ? polygons[0] : polygons;
        };
        const currPoly = shapesToMartinezPolygon(data.shapesContorno, [], data);
        const prevPoly = shapesToMartinezPolygon(tapas2Data[idx - 1].shapesContorno, [], tapas2Data[idx - 1]);
        const inter = martinez.intersection(currPoly, prevPoly);
        // tu lógica adicional sobre 'inter' quedaría aquí (la dejé en blanco intencionalmente)
      } catch (e) {
        console.error("Error generando borde desde base:", e);
      }
    }

    // 3) RESTAR CANALES INTERNOS
    if (rects && rects.length) {
      baseCSG = subtractChannels(baseCSG, rects, data, CHANNEL_DEPTH);
      anilloCSG = subtractChannels(anilloCSG, rects, data, CHANNEL_DEPTH);
    }

    // 4) Orange extrusion y unión con anillo/base
    if (data.shapesNaranja && data.shapesNaranja.length > 0) {
      try {
        const orangeShapesForExtrude = data.shapesNaranja.map((s) => new THREE.Shape(s.getPoints(SAMPLE)));
        let orangeCSG = extrudeToCSG(orangeShapesForExtrude, ORANGE_DEPTH, 5 + EPS);
        if (!orangeCSG) throw new Error("orangeCSG null");

        if (rects && rects.length) orangeCSG = subtractChannels(orangeCSG, rects, data, CHANNEL_DEPTH);

        if (idx > 0) orangeCSG = subtractPreviousIfAny(orangeCSG, tapas2Data[idx - 1], ORANGE_DEPTH, 5 + EPS);

        try {
          anilloCSG = anilloCSG.union(orangeCSG);
          console.debug("[export] orange union OK letter:", data.letra);
        } catch (e) {
          console.warn("[export] fallo al unir orange/anillo:", e);
          try {
            baseCSG = baseCSG.union(orangeCSG);
            console.debug("[export] orange unido a baseCSG como fallback para:", data.letra);
          } catch (e2) {
            console.error("[export] no se pudo unir orange a ninguna CSG:", e2);
          }
        }
      } catch (errOrange) {
        console.error("[export] fallo extruir orange para letra", data.letra, errOrange);
      }
    }

    // ----------------------------------------------------------------------------
    // ---------- CONSTRUCCIÓN Y EXPORT DE LA "TAPA RESULTANTE" ----------
    try {
      const TAPA_BASE_DEPTH = 3;
      const TAPA_BORDER_DEPTH = 6;
      const OFFSET_MM = 0;

      // tapa base
      let tapaBaseCSG = extrudeToCSG(baseShapesForTapa, TAPA_BASE_DEPTH, 0);
      if (!tapaBaseCSG) throw new Error("tapaBaseCSG null");

      // aplicar rects a tapa
      if (rects && rects.length) {
        tapaBaseCSG = subtractChannels(tapaBaseCSG, rects, data, CHANNEL_DEPTH);
      }

      // restar shapesLetraForTapa de la tapa base (normalizados)
      if (shapesLetraForTapa && shapesLetraForTapa.length) {
        try {
          const letraShapesForCut = shapesLetraForTapa.map(s => normalizeShapeForCSG_local(s));
          let letraGeomCut = new THREE.ExtrudeGeometry(letraShapesForCut, { depth: TAPA_BASE_DEPTH + 10, bevelEnabled: false });
          letraGeomCut = toGlobal(letraGeomCut, data, 5 + EPS);
          letraGeomCut = cleanGeometry(letraGeomCut);
          tapaBaseCSG = tapaBaseCSG.subtract(CSG.fromMesh(new THREE.Mesh(letraGeomCut)));
        } catch (e) {
          console.warn("[tapa] fallo restando shapesLetraForTapa a tapaBaseCSG:", e);
        }
      }

      // restar prev (letrasData) si aplica
      if (idx > 0) {
        tapaBaseCSG = subtractPreviousIfAny(tapaBaseCSG, letrasData[idx - 1], TAPA_BASE_DEPTH, 0);
      }

      // contorno (shapesContorno) -> extruir y restar
      if (data.shapesContorno && data.shapesContorno.length) {
        const offsetShapesContorno = offsetPathArray_local(data.shapesContorno, OFFSET_MM);
        const usedContorno = offsetShapesContorno.length ? offsetShapesContorno : data.shapesContorno;

        const contourShapes = usedContorno.map((cont) => {
          const s = new THREE.Shape(cont.getPoints(SAMPLE));
          if (shapesLetraForTapa && shapesLetraForTapa.length) {
          
            shapesLetraForTapa.forEach((hole) => {
              const normHole = normalizeShapeForCSG_local(hole);
              if (normHole && normHole.getPoints().length >= 3) {
                s.holes.push(new THREE.Path(normHole.getPoints(SAMPLE)));
              }
            });
            
          } else if (data.shapesLetra && data.shapesLetra.length) {
            data.shapesLetra.forEach((hole) => s.holes.push(new THREE.Path(hole.getPoints(SAMPLE))));
          }
          return s;
        });

        let contourCSG = extrudeToCSG(contourShapes, TAPA_BASE_DEPTH, 0);
        if (contourCSG && contourCSG.polygons && contourCSG.polygons.length > 0) {
          try {
            tapaBaseCSG = tapaBaseCSG.subtract(contourCSG);
            console.debug("[tapa] resta contorno OK para letra:", data.letra);
          } catch (e) {
            console.warn("[tapa] contorno conflictivo, se omite resta:", e);
          }
        } else {
          console.debug("[tapa] contorno vacío o sin polígonos");
        }
      } else {
        console.debug("[tapa] no hay shapesContorno para restar");
      }

      // ---- Exportar tapa STL individual ----
      const tapaResultMesh = CSG.toMesh(tapaBaseCSG, new THREE.Matrix4());
      tapaResultMesh.geometry.deleteAttribute('normal');
      tapaResultMesh.geometry = mergeVertices(tapaResultMesh.geometry, 1e-5);
      tapaResultMesh.geometry = cleanGeometry(tapaResultMesh.geometry);
      tapaResultMesh.geometry.computeVertexNormals();         
      tapaResultMesh.updateMatrix();

      // Centrar en el origen antes de exportar
      const tmpTapa = new THREE.Mesh(tapaResultMesh.geometry.clone());
      const boxTapa = new THREE.Box3().setFromObject(tmpTapa);
      const centerTapa = boxTapa.getCenter(new THREE.Vector3());
      tmpTapa.geometry.translate(-centerTapa.x, -centerTapa.y, -centerTapa.z);

      const stlTapa = exporter.parse(tmpTapa, { binary: true });
      const blobTapa = new Blob([stlTapa], { type: "application/octet-stream" });
      const linkTapa = document.createElement("a");
      linkTapa.href = URL.createObjectURL(blobTapa);
      linkTapa.download = `Tapa_${data.letra || idx}.stl`;
      document.body.appendChild(linkTapa);
      linkTapa.click();
      document.body.removeChild(linkTapa);
    } catch (e) {
      console.error("Error generando tapa resultante para letra", data.letra, e);
    }
  } catch (err) {
    console.error("Error generando STL de la letra:", data.letra, err);
  }
};
const descargarCUBIERTASTLPorLetra = (data, idx) => {
  const exporter = new STLExporter();
  const EPS = 0.05;
  const OFFSET_EXTERNO = -4;
  const CLIPPER_SCALE = precisionEscala || 1000;
  const SAMPLE = SAMPLE_POINTS || 12;

  // ---------------- HELPERS UTILES ----------------
  const toGlobal = (geom, d, z = 0) => {
    geom.translate(d.posX - d.anchoLetra / 2, -d.altoTotal / 2, z);
    return geom;
  };

  const safeNumber = (v, fallback = 0) => (typeof v === 'number' ? v : fallback);

  // Convierte array THREE.Vector2-like a path clipper y viceversa
  const ptsToClipper = (pts) => pts.map(p => ({ X: Math.round(p.x * CLIPPER_SCALE), Y: Math.round(p.y * CLIPPER_SCALE) }));
  const pathToShape = (path) => {
    const pts = path.map(p => new THREE.Vector2(p.X / CLIPPER_SCALE, p.Y / CLIPPER_SCALE));
    return new THREE.Shape(pts);
  };

  // normaliza cualquier shape/path para CSG
  const normalizeShapeForCSG_local = (shapeOrPath, opts = {}) => {
    const SAMPLE_LOCAL = opts.samplePoints || SAMPLE;
    let pts = [];
    try {
      pts = shapeOrPath.getPoints ? shapeOrPath.getPoints(SAMPLE_LOCAL) : shapeOrPath;
    } catch (e) {
      if (Array.isArray(shapeOrPath)) pts = shapeOrPath;
      else pts = [];
    }
    if (!pts || pts.length < 3) return new THREE.Shape([]);
    // transform to Vector2 array
    pts = pts.map(p => (p.x !== undefined ? new THREE.Vector2(p.x, p.y) : new THREE.Vector2(p[0], p[1])));
    // reuse tus funciones: uniqueConsecutivePoints, removeCollinear, clipperCleanPath, ensureCCW
    const uniqueConsecutivePoints = (points, eps = 1e-5) => {
      if (!points || !points.length) return [];
      const out = [points[0]];
      for (let i = 1; i < points.length; i++) {
        const a = points[i - 1], b = points[i];
        if (Math.hypot(b.x - a.x, b.y - a.y) > eps) out.push(b);
      }
      if (out.length > 1) {
        const first = out[0], last = out[out.length - 1];
        if (Math.hypot(last.x - first.x, last.y - first.y) < eps) out[out.length - 1] = first;
      }
      return out;
    };
    const removeCollinear = (points, eps = 1e-8) => {
      if (!points || points.length < 3) return points.slice();
      const out = [];
      for (let i = 0; i < points.length; i++) {
        const a = points[(i - 1 + points.length) % points.length];
        const b = points[i];
        const c = points[(i + 1) % points.length];
        const cross = (b.x - a.x) * (c.y - b.y) - (b.y - a.y) * (c.x - b.x);
        if (Math.abs(cross) > eps) out.push(b);
      }
      return out.length ? out : points.slice();
    };
    const ensureCCW = (points) => {
      let a = 0;
      for (let i = 0; i < points.length; i++) {
        const p0 = points[i], p1 = points[(i + 1) % points.length];
        a += p0.x * p1.y - p1.x * p0.y;
      }
      return a < 0 ? points.slice().reverse() : points;
    };
    const clipperCleanPathLocal = (pointsArr, cleanOffsetMm = 0.05) => {
      if (typeof ClipperLib === "undefined" || !pointsArr || pointsArr.length < 3) return null;
      try {
        const path = pointsArr.map(p => ({ X: Math.round(p.x * CLIPPER_SCALE), Y: Math.round(p.y * CLIPPER_SCALE) }));
        const co1 = new ClipperLib.ClipperOffset();
        co1.AddPath(path, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
        const sol1 = new ClipperLib.Paths();
        co1.Execute(sol1, Math.round(cleanOffsetMm * CLIPPER_SCALE));
        if (!sol1 || sol1.length === 0) return null;
        const co2 = new ClipperLib.ClipperOffset();
        sol1.forEach(pth => co2.AddPath(pth, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon));
        const sol2 = new ClipperLib.Paths();
        co2.Execute(sol2, -Math.round(cleanOffsetMm * CLIPPER_SCALE));
        if (!sol2 || sol2.length === 0) return null;
        return sol2[0].map(pt => ({ x: pt.X / CLIPPER_SCALE, y: pt.Y / CLIPPER_SCALE }));
      } catch (err) {
        console.warn("[normalize] fallo clipperCleanPath:", err);
        return null;
      }
    };

    let cleaned = uniqueConsecutivePoints(pts, 1e-5);
    if (cleaned.length < 3) return new THREE.Shape(cleaned);
    cleaned = removeCollinear(cleaned, 1e-9);
    if (cleaned.length < 3) return new THREE.Shape(cleaned);
    const cleanedByClipper = clipperCleanPathLocal(cleaned, 0.05) || clipperCleanPathLocal(cleaned, 0.2) || null;
    let finalPts = cleanedByClipper && cleanedByClipper.length >= 3 ? cleanedByClipper.map(p => new THREE.Vector2(p.x, p.y)) : cleaned;
    finalPts = ensureCCW(finalPts);
    return new THREE.Shape(finalPts);
  };

  // ----------------- CLIPPER / OFFSET -----------------
  const offsetTHREEShapeOrPath_local = (shapeOrPath, deltaMm) => {
    let pts = [];
    try {
      pts = shapeOrPath.getPoints ? shapeOrPath.getPoints(SAMPLE) : shapeOrPath;
    } catch (e) {
      if (Array.isArray(shapeOrPath)) pts = shapeOrPath;
      else pts = [];
    }
    if (typeof ClipperLib !== "undefined") {
      const p = pts.map(pt => ({ X: Math.round(pt.x * CLIPPER_SCALE), Y: Math.round(pt.y * CLIPPER_SCALE) }));
      const co = new ClipperLib.ClipperOffset();
      co.AddPath(p, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
      const sol = new ClipperLib.Paths();
      co.Execute(sol, Math.round(deltaMm * CLIPPER_SCALE));
      if (sol && sol.length) return sol.map(path => pathToShape(path));
      return [];
    }
    // Fallback: approximate scale about center
    if (!pts || pts.length === 0) return [];
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    pts.forEach(p => { minX = Math.min(minX, p.x); minY = Math.min(minY, p.y); maxX = Math.max(maxX, p.x); maxY = Math.max(maxY, p.y); });
    const width = maxX - minX, height = maxY - minY, centerX = (minX + maxX) / 2, centerY = (minY + maxY) / 2;
    const avgDim = Math.max(width, height) || 1;
    const scale = Math.max(0.01, (avgDim + 2 * deltaMm) / avgDim);
    const scaledPts = pts.map(p => new THREE.Vector2(centerX + (p.x - centerX) * scale, centerY + (p.y - centerY) * scale));
    return [new THREE.Shape(scaledPts)];
  };

  const offsetPathArray_local = (pathsArray, deltaMm) => {
    const out = [];
    if (!pathsArray || !pathsArray.length) return out;
    pathsArray.forEach(p => {
      const res = offsetTHREEShapeOrPath_local(p, deltaMm);
      if (res && res.length) res.forEach(s => out.push(s));
    });
    return out;
  };

  // ----------------- OPERACIONES CSG/GEOMETRIA UTILES -----------------
  const extrudeToCSG = (shapes, depth, z = 0, opts = {}) => {
    try {
      const geo = new THREE.ExtrudeGeometry(shapes, { depth: depth, bevelEnabled: false, curveSegments: opts.curveSegments || CURVE_SEGMENTS });
      toGlobal(geo, data, z);
      const cleaned = cleanGeometry(geo);
      const mesh = new THREE.Mesh(cleaned);
      mesh.updateMatrix();
      return CSG.fromMesh(mesh);
    } catch (e) {
      console.error("[extrudeToCSG] fallo extruir -> CSG:", e);
      return null;
    }
  };

  const subtractChannels = (targetCSG, rectsList, dataLocal, depthForChannel) => {
    if (!rectsList || !rectsList.length) return targetCSG;
    const minZ = WALL_THICKNESS_TOP_BOTTOM;
    const maxZ = Math.max(0, BASE_DEPTH - WALL_THICKNESS_TOP_BOTTOM - CHANNEL_DEPTH);
    const safeChannelZ = Math.min(Math.max(CHANNEL_Z, minZ), maxZ);
    rectsList.forEach((r) => {
      const canalGeom = new THREE.BoxGeometry(r.w, r.h, depthForChannel || CHANNEL_DEPTH);
      canalGeom.translate(r.x, r.y, safeChannelZ + (depthForChannel || CHANNEL_DEPTH) / 2);
      const canalClean = cleanGeometry(canalGeom);
      const canalMesh = new THREE.Mesh(canalClean);
      canalMesh.updateMatrix();
      const canalCSG = CSG.fromMesh(canalMesh);
      try { targetCSG = targetCSG.subtract(canalCSG); } catch (e) { console.warn("[subtractChannels] fallo resta canal:", e); }
    });
    return targetCSG;
  };

  const subtractPreviousIfAny = (targetCSG, prevData, depth, zOffset = 0) => {
    if (!prevData) return targetCSG;
    try {
      const prevPaths = (prevData.shapesContorno || []).map(s => {
        const pts = s.getPoints(SAMPLE).map(p => ({
          X: Math.round((p.x + (prevData.posX - prevData.anchoLetra/2)) * CLIPPER_SCALE),
          Y: Math.round((p.y + (-prevData.altoTotal/2)) * CLIPPER_SCALE)
        }));
        return pts;
      }).filter(p => p && p.length > 2);
  
      const currPaths = (data.shapesContorno || []).map(s => {
        const pts = s.getPoints(SAMPLE).map(p => ({
          X: Math.round((p.x + (data.posX - data.anchoLetra/2)) * CLIPPER_SCALE),
          Y: Math.round((p.y + (-data.altoTotal/2)) * CLIPPER_SCALE)
        }));
        return pts;
      }).filter(p => p && p.length > 2);
  
      if (!prevPaths.length || !currPaths.length) return targetCSG;
  
      // Intersección entre cortes
      const c = new ClipperLib.Clipper();
      c.AddPaths(prevPaths, ClipperLib.PolyType.ptSubject, true);
      c.AddPaths(currPaths, ClipperLib.PolyType.ptClip, true);
      const interRes = new ClipperLib.Paths();
      c.Execute(
        ClipperLib.ClipType.ctIntersection,
        interRes,
        ClipperLib.PolyFillType.pftEvenOdd,
        ClipperLib.PolyFillType.pftEvenOdd
      );
  
      if (!interRes || !interRes.length) return targetCSG;
  
      // ✅ aplicar offset adicional SOLO a la intersección detectada
      const co = new ClipperLib.ClipperOffset();
      interRes.forEach(path => {
        co.AddPath(path, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
      });
      const interOffset = new ClipperLib.Paths();
      co.Execute(interOffset, Math.round(4 * CLIPPER_SCALE)); // 4mm extra
  
      if (!interOffset.length) return targetCSG;
  
      // Convertir a Shape y extruir
      const interShapes = interOffset.map(path => {
        const pts = path.map(pt => new THREE.Vector2(
          pt.X / CLIPPER_SCALE - (data.posX - data.anchoLetra/2),
          pt.Y / CLIPPER_SCALE - (-data.altoTotal/2)
        ));
        return new THREE.Shape(pts);
      });
  
      let prevGeom = new THREE.ExtrudeGeometry(interShapes, { depth, bevelEnabled: false });
      prevGeom = toGlobal(prevGeom, data, zOffset);
      prevGeom = cleanGeometry(prevGeom);
      const prevMesh = new THREE.Mesh(prevGeom);
      prevMesh.updateMatrix();
      const prevCSG = CSG.fromMesh(prevMesh);
  
      return targetCSG.subtract(prevCSG);
    } catch (e) {
      console.warn("[subtractPreviousIfAny] fallo prev subtraction:", e);
      return targetCSG;
    }
  };
  
  

  // ---------------- INICIO PIPELINE (mantener tu lógica) ----------------
  try {
    // Ajustar shapes con offset externo (si aplica)
    const adjustedShapesLetra = data.shapesLetra && data.shapesLetra.length ? offsetPathArray_local(data.shapesLetra, OFFSET_EXTERNO) : [];
    const shapesLetraForTapa = adjustedShapesLetra.length ? adjustedShapesLetra : (data.shapesLetra || []);

    const adjustedShapesNaranja = data.shapesNaranja && data.shapesNaranja.length ? offsetPathArray_local(data.shapesNaranja, OFFSET_EXTERNO) : [];
    const shapesNaranjaForTapa = adjustedShapesNaranja.length ? adjustedShapesNaranja : (data.shapesNaranja || []);

    // Build baseShapesForTapa (same)
    const baseShapesForTapa = [];
    if (shapesLetraForTapa && shapesLetraForTapa.length) shapesLetraForTapa.forEach(s => baseShapesForTapa.push(new THREE.Shape(s.getPoints(SAMPLE))));
    if (shapesNaranjaForTapa && shapesNaranjaForTapa.length) shapesNaranjaForTapa.forEach(s => baseShapesForTapa.push(new THREE.Shape(s.getPoints(SAMPLE))));

    // 1) Base y cortes existentes
    let baseGeom = new THREE.ExtrudeGeometry(data.shapesContorno, { depth: BASE_DEPTH, bevelEnabled: false });
    baseGeom = toGlobal(baseGeom, data, 0);
    baseGeom = cleanGeometry(baseGeom);
    let baseCSG = CSG.fromMesh(new THREE.Mesh(baseGeom));

    // Extruir letra y restar de base
    let letraGeom = new THREE.ExtrudeGeometry(data.shapesLetra, { depth: 55, bevelEnabled: false });
    letraGeom = toGlobal(letraGeom, data, 5 + EPS);
    letraGeom = cleanGeometry(letraGeom);
    const letraCSG = CSG.fromMesh(new THREE.Mesh(letraGeom));
    baseCSG = baseCSG.subtract(letraCSG);

    // Si hay anterior (tapas2Data), restar
    if (idx > 0) {
      baseCSG = subtractPreviousIfAny(baseCSG, tapas2Data[idx - 1], BASE_DEPTH, 0);
    }

    // 2) Anillo blanco
    const anilloShapes = data.shapesContorno.map((cont) => {
      const s = new THREE.Shape(cont.getPoints(SAMPLE));
      (data.shapesBordeNegro || []).forEach((h) => s.holes.push(new THREE.Path(h.getPoints(SAMPLE))));
      return s;
    });
    let anilloGeom = new THREE.ExtrudeGeometry(anilloShapes, { depth: bordeblancoalto, bevelEnabled: false });
    anilloGeom = toGlobal(anilloGeom, data, 5 + EPS);
    anilloGeom = cleanGeometry(anilloGeom);
    let anilloCSG = CSG.fromMesh(new THREE.Mesh(anilloGeom));

    if (idx > 0) {
      anilloCSG = subtractPreviousIfAny(anilloCSG, tapas2Data[idx - 1], bordeblancoalto, 5 + EPS);
      // Intento de martinez intersection como en tu bloque original
      try {
        const shapesToMartinezPolygon = (outerShapes, holesArray, dLocal) => {
          const polygons = [];
          outerShapes.forEach((outerShape) => {
            const outer = outerShape.getPoints(SAMPLE).map(p => [p.x + (dLocal.posX - dLocal.anchoLetra / 2), p.y + (-dLocal.altoTotal / 2)]);
            const holes = (holesArray || []).map(h => h.getPoints(SAMPLE).map(p => [p.x + (dLocal.posX - dLocal.anchoLetra / 2), p.y + (-dLocal.altoTotal / 2)]));
            polygons.push([outer, ...holes]);
          });
          return polygons.length === 1 ? polygons[0] : polygons;
        };
        const currPoly = shapesToMartinezPolygon(data.shapesContorno, [], data);
        const prevPoly = shapesToMartinezPolygon(tapas2Data[idx - 1].shapesContorno, [], tapas2Data[idx - 1]);
        const inter = martinez.intersection(currPoly, prevPoly);
        // tu lógica adicional sobre 'inter' quedaría aquí (la dejé en blanco intencionalmente)
      } catch (e) {
        console.error("Error generando borde desde base:", e);
      }
    }

    // 3) RESTAR CANALES INTERNOS
    if (rects && rects.length) {
      baseCSG = subtractChannels(baseCSG, rects, data, CHANNEL_DEPTH);
      anilloCSG = subtractChannels(anilloCSG, rects, data, CHANNEL_DEPTH);
    }

    // ----------------------------------------------------------------------------
    // ---------- CONSTRUCCIÓN Y EXPORT DE LA "TAPA RESULTANTE" ----------
    try {
      const TAPA_BASE_DEPTH = 2;
      const OFFSET_MM = 3.5;

      // tapa base
      let tapaBaseCSG = extrudeToCSG(baseShapesForTapa, TAPA_BASE_DEPTH, 0);
      if (!tapaBaseCSG) throw new Error("tapaBaseCSG null");

      // aplicar rects a tapa
      if (rects && rects.length) {
        tapaBaseCSG = subtractChannels(tapaBaseCSG, rects, data, CHANNEL_DEPTH);
      }

      // restar shapesLetraForTapa de la tapa base (normalizados)
      if (shapesLetraForTapa && shapesLetraForTapa.length) {
        try {
          const letraShapesForCut = shapesLetraForTapa.map(s => normalizeShapeForCSG_local(s));
          let letraGeomCut = new THREE.ExtrudeGeometry(letraShapesForCut, { depth: TAPA_BASE_DEPTH + 10, bevelEnabled: false });
          letraGeomCut = toGlobal(letraGeomCut, data, 5 + EPS);
          letraGeomCut = cleanGeometry(letraGeomCut);
          tapaBaseCSG = tapaBaseCSG.subtract(CSG.fromMesh(new THREE.Mesh(letraGeomCut)));
        } catch (e) {
          console.warn("[tapa] fallo restando shapesLetraForTapa a tapaBaseCSG:", e);
        }
      }

      // restar prev (letrasData) si aplica
      if (idx > 0) {
        tapaBaseCSG = subtractPreviousIfAny(tapaBaseCSG, letrasData[idx - 1], TAPA_BASE_DEPTH, 0);
      }

      // contorno (shapesContorno) -> extruir y restar
      if (data.shapesContorno && data.shapesContorno.length) {
        const offsetShapesContorno = offsetPathArray_local(data.shapesContorno, OFFSET_MM);
        const usedContorno = offsetShapesContorno.length ? offsetShapesContorno : data.shapesContorno;

        const contourShapes = usedContorno.map((cont) => {
          const s = new THREE.Shape(cont.getPoints(SAMPLE));
          if (shapesLetraForTapa && shapesLetraForTapa.length) {
          
            shapesLetraForTapa.forEach((hole) => {
              const normHole = normalizeShapeForCSG_local(hole);
              if (normHole && normHole.getPoints().length >= 3) {
                s.holes.push(new THREE.Path(normHole.getPoints(SAMPLE)));
              }
            });
            
          } else if (data.shapesLetra && data.shapesLetra.length) {
            data.shapesLetra.forEach((hole) => s.holes.push(new THREE.Path(hole.getPoints(SAMPLE))));
          }
          return s;
        });

        let contourCSG = extrudeToCSG(contourShapes, TAPA_BASE_DEPTH, 0);
        if (contourCSG && contourCSG.polygons && contourCSG.polygons.length > 0) {
          try {
            tapaBaseCSG = tapaBaseCSG.subtract(contourCSG);
            console.debug("[tapa] resta contorno OK para letra:", data.letra);
          } catch (e) {
            console.warn("[tapa] contorno conflictivo, se omite resta:", e);
          }
        } else {
          console.debug("[tapa] contorno vacío o sin polígonos");
        }
      } else {
        console.debug("[tapa] no hay shapesContorno para restar");
      }





      
      // ---- Exportar tapa STL individual ----
      const tapaResultMesh = CSG.toMesh(tapaBaseCSG, new THREE.Matrix4());
      tapaResultMesh.geometry.deleteAttribute('normal');
      tapaResultMesh.geometry = mergeVertices(tapaResultMesh.geometry, 1e-5);
      tapaResultMesh.geometry = cleanGeometry(tapaResultMesh.geometry);
      tapaResultMesh.geometry.computeVertexNormals();         
      tapaResultMesh.updateMatrix();

      // Centrar en el origen antes de exportar
      const tmpTapa = new THREE.Mesh(tapaResultMesh.geometry.clone());
      const boxTapa = new THREE.Box3().setFromObject(tmpTapa);
      const centerTapa = boxTapa.getCenter(new THREE.Vector3());
      tmpTapa.geometry.translate(-centerTapa.x, -centerTapa.y, -centerTapa.z);

      const stlTapa = exporter.parse(tmpTapa, { binary: true });
      const blobTapa = new Blob([stlTapa], { type: "application/octet-stream" });
      const linkTapa = document.createElement("a");
      linkTapa.href = URL.createObjectURL(blobTapa);
      linkTapa.download = `Contorno_${data.letra || idx}.stl`;
      document.body.appendChild(linkTapa);
      linkTapa.click();
      document.body.removeChild(linkTapa);
    } catch (e) {
      console.error("Error generando tapa resultante para letra", data.letra, e);
    }
  } catch (err) {
    console.error("Error generando STL de la letra:", data.letra, err);
  }
};


  //-----------------------******
  
  

  // ======= Drag de rectángulos en 3D (plano Z=0) =======
  function DraggableRect({ r, setRects, setSelectedId }) {
    const meshRef = useRef();
    const { camera, gl } = useThree();
  
    const plane = useMemo(() => new THREE.Plane(new THREE.Vector3(0, 0, 1), 0), []);
    const raycaster = useMemo(() => new THREE.Raycaster(), []);
    const offset = useRef(new THREE.Vector3());
    const isDragging = useRef(false);
  
    const screenToWorld = (clientX, clientY) => {
      const rect = gl.domElement.getBoundingClientRect();
      const x = ((clientX - rect.left) / rect.width) * 2 - 1;
      const y = -((clientY - rect.top) / rect.height) * 2 + 1;
      raycaster.setFromCamera({ x, y }, camera);
      const point = new THREE.Vector3();
      raycaster.ray.intersectPlane(plane, point);
      return point;
    };
  
    const onPointerDown = (e) => {
      e.stopPropagation();
      setSelectedId(r.id);
  
      const p = screenToWorld(e.clientX, e.clientY);
      offset.current.copy(p).sub(new THREE.Vector3(r.x, r.y, 0));
      isDragging.current = true;
  
      window.addEventListener("pointermove", onWindowMove);
      window.addEventListener("pointerup", onWindowUp);
    };
  
    const onWindowMove = (e) => {
      if (!isDragging.current) return;
      const p = screenToWorld(e.clientX, e.clientY);
      const nx = p.x - offset.current.x;
      const ny = p.y - offset.current.y;
  
      setRects((arr) =>
        arr.map((it) => (it.id === r.id ? { ...it, x: nx, y: ny } : it))
      );
    };
  
    const onWindowUp = () => {
      isDragging.current = false;
      window.removeEventListener("pointermove", onWindowMove);
      window.removeEventListener("pointerup", onWindowUp);
    };
  
    return (
      <mesh
        ref={meshRef}
        // ⬇️ subimos el rectángulo un poco en Z para evitar solapamiento
        position={[r.x, r.y, 0.5]}
        renderOrder={999} // forzar a dibujarse al final
        onPointerDown={onPointerDown}
        onPointerMissed={() => setSelectedId(null)}
      >
        <planeGeometry args={[r.w, r.h]} />
        <meshBasicMaterial
          color={"#FFE800"}
          opacity={0.9}
          transparent
          depthTest={false} // ignora el z-buffer → siempre visible
        />
      </mesh>
    );
  }
  
  // ====== Helpers UI rectángulos ======
  const addRect = () => {
    // punto medio del texto
    const midX = 0;
    const midY = 0;
    const w = Math.max(10, size * 0.6);
    const h = Math.max(6, size * 0.2);
    const id = crypto.randomUUID();
    const DEFAULT_DEPTH = 10; // valor inicial de profundidad (puedes ajustarlo)
    const nr = { id, x: midX, y: midY, w, h, depth: DEFAULT_DEPTH };

    setRects((a) => [...a, nr]);
    setSelectedId(id);
  };
  const sel = rects.find((r) => r.id === selectedId);

  return (
    <div style={{ padding: 20, background: "white" }}>
      <h2 style={{ color: "black" }}>💡 Boceto 2D del Nombre</h2>
  
      <div style={{ margin: "10px 0" }}>
        <label style={{ color: "black" }}>
          Fuente:{" "}
          <select value={fuenteSeleccionada} onChange={(e) => setFuenteSeleccionada(e.target.value)}>
            {Object.keys(fuentesDisponibles).map((fuente) => (
              <option key={fuente} value={fuente}>
                {fuente}
              </option>
            ))}
          </select>
        </label>
      </div>
  
      <div style={{ margin: "10px 0" }}>
        <label style={{ color: "black" }}>
          Nombre:{" "}
          <input value={nombre} onChange={(e) => setNombre(e.target.value.toUpperCase())} />
        </label>
      </div>
  
      <div style={{ display: "grid", gap: "10px", marginBottom: "15px" }}>
      <label>
  Zoom previsualización: {zoom}
  <input
    type="range"
    min="0.5"
    max="5"
    step="0.1"
    value={zoom}
    onChange={(e) => setZoom(Number(e.target.value))}
  />
  <button onClick={() => setZoom(4)} style={{ marginLeft: 8 }}>Reset</button>
</label>

        <label>
          Tamaño fuente: {size}
          <input type="range" min="20" max="250" value={size} onChange={(e) => setSize(Number(e.target.value))} />
        </label>
        <label>
          Grosor contorno: {contornoDistancia}
          <input
            type="range"
            min="0"
            max="20"
            step="0.5"
            value={contornoDistancia}
            onChange={(e) => setContornoDistancia(Number(e.target.value))}
          />
        </label>
        <label>
          Grosor borde negro: {bordeNegroDistancia}
          <input
            type="range"
            min="-10"
            max="0"
            step="0.1"
            value={bordeNegroDistancia}
            onChange={(e) => setBordeNegroDistancia(Number(e.target.value))}
          />
        </label>
        <label>
          Espaciado letras: {espaciado}
          <input type="range" min="-20" max="40" step="1" value={espaciado} onChange={(e) => setEspaciado(Number(e.target.value))} />
        </label>
      </div>
  

<button
onClick={descargarSTL}
style={{ padding: "10px", background: "#222", color: "white", borderRadius: "8px" }}
>
Descargar Letras STL
</button>

<button
onClick={descargarTapasSTL}
style={{ padding: "10px", background: "#222", color: "white", borderRadius: "8px" }}
>
Descargar TAPAS STL
</button>





      <div className="descargas">
  {letrasData.map((data, idx) => (
    <button key={idx} onClick={() => descargarSTLPorLetra(data, idx)}>
      Descargar {data.letra}
    </button>
  ))}
</div>


<div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 12 }}>
  {tapas2Data.map((data, idx) => (
    <button
      key={idx}
      onClick={() => descargarTapaSTLPorLetra(data, idx)}
      style={{ padding: "8px 10px", background: "#0b84ff", color: "white", borderRadius: 6, border: "none", cursor: "pointer" }}
    >
      Descargar Tapa {data.letra || idx + 1}
    </button>
  ))}
</div>



<div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 12 }}>
  {tapas2Data.map((data, idx) => (
    <button
      key={idx}
      onClick={() => descargarCUBIERTASTLPorLetra(data, idx)}
      style={{ padding: "8px 10px", background: "#27F554", color: "white", borderRadius: 6, border: "none", cursor: "pointer" }}
    >
      Descargar Cubierta {data.letra || idx + 1}
    </button>
  ))}
</div>




  
      <div style={{ margin: "10px 0" }}>
        <label style={{ color: "black" }}>
          <input
            type="checkbox"
            checked={agregarAgujeros}
            onChange={(e) => setAgregarAgujeros(e.target.checked)}
          />
          {" "}Agregar Rectángulos de CORTE (tubería)
        </label>
        {" "}
        {agregarAgujeros && (
          <button onClick={addRect} style={{ padding: "6px 10px", borderRadius: 6 }}>➕ Añadir rectángulo</button>
        )}
      </div>


  
      {agregarAgujeros && sel && (
  <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 8 }}>
    <span style={{ color: "black" }}>Rectángulo seleccionado:</span>

    <label>W
      <input
        type="number"
        value={Math.round(sel.w)}
        onChange={(e) =>
          setRects((a) => a.map((r) => (r.id === sel.id ? { ...r, w: Math.max(2, +e.target.value) } : r)))
        }
        style={{ width: 70, marginLeft: 6 }}
      />
    </label>

    <label>H
      <input
        type="number"
        value={Math.round(sel.h)}
        onChange={(e) =>
          setRects((a) => a.map((r) => (r.id === sel.id ? { ...r, h: Math.max(2, +e.target.value) } : r)))
        }
        style={{ width: 70, marginLeft: 6 }}
      />
    </label>

    <label>Z
      <input
        type="number"
        value={Math.round(sel.depth)}
        min={1}
        max={BASE_DEPTH}
        step={1}
        onChange={(e) => {
          const val = Number(e.target.value);
          setRects((arr) =>
            arr.map((it) => (it.id === selectedId ? { ...it, depth: val } : it))
          );
        }}
        style={{ width: 70, marginLeft: 6 }}
      />
    </label>

    <button onClick={() => setRects((a) => a.filter((r) => r.id !== sel.id))}>
      Eliminar
    </button>
  </div>
)}

  
      {agregarAgujeros && (
        <div style={{ color: "#3b82f6", display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
          🗑️ Arrastra un rectángulo hasta el basurero (esquina superior derecha azul) para borrarlo.
        </div>
      )}
  
      <div style={{ marginTop: 5, height: 420, position: "relative" }}>
        {agregarAgujeros && (
          <div
            style={{
              position: "absolute",
              right: 16,
              top: 6,
              zIndex: 10,
              fontSize: 24,
              color: "#3b82f6",
              pointerEvents: "none",
              userSelect: "none",
            }}
          >
            🗑️
          </div>
        )}
  
{/* --- Canvas (reemplazar el bloque actual) --- */}
<Canvas orthographic camera={{ position: [0, 0, 200] }}>
  <CameraZoomController zoom={zoom} />
  <ambientLight />

  {/** Normalizador visual: escala inversa basada en size para que el canvas no "explote" */}
  {/* Ajusta REFERENCE_DISPLAY_SIZE si quieres la escala por defecto */}
  {(() => {
    const REFERENCE_DISPLAY_SIZE = 160; // tamaño de referencia para la vista (puedes ajustar)
    // displayScale = referencia / size, clamp para evitar valores extremos
    const raw = REFERENCE_DISPLAY_SIZE / Math.max(1, size);
    const displayScale = Math.max(0.08, Math.min(6, raw)); // clamp entre 0.08 y 6
    return (
      <group scale={[displayScale, displayScale, 1]}>
        {letrasData.map((data, index) => (
          <group key={index} position={[data.posX, 0, -(index)]}>
            {/* Contorno de color */}
            <mesh geometry={data.contornoGeom} >
              <meshBasicMaterial color={data.bordeColor} side={THREE.DoubleSide} />
            </mesh>

            {/* Fondo blanco */}
            <mesh geometry={data.textoGeom} position={[0, 0, 0.005]}>
              <meshBasicMaterial color="white" side={THREE.DoubleSide} />
            </mesh>

            {/* Borde negro */}
            <mesh geometry={data.bordeNegroGeom} position={[0, 0, 0.0057]}>
              <meshBasicMaterial color="black" side={THREE.DoubleSide} />
            </mesh>

            {/* Delineado naranja */}
            <mesh geometry={data.orangeGeom} position={[0, 0, 0.006]}>
              <meshBasicMaterial
                color="#FF6A00"
                side={THREE.DoubleSide}
                polygonOffset
                polygonOffsetFactor={-1}
              />
            </mesh>
          </group>
        ))}

        {/* Rectángulos arrastrables: los dejamos dentro del mismo group para que hereden la escala */}
        {agregarAgujeros &&
          rects.map((r) => (
            <DraggableRect
              key={r.id}
              r={r}
              setRects={setRects}
              setSelectedId={setSelectedId}
            />
          ))}
      </group>
    );
  })()}
</Canvas>

      </div>
    </div>
  );
  
}









































































































































































































































































